<template>
  <div id="AdmissionRequirements">
    <v-card outlined class="mt-3">
      <v-layout
        row
        align-center
        justify-center
        class="grey lighten-4 pb-2 mx-0"
      >
        <span class="title font-weight-regular  align-center mt-1"
          >Admission Requirements
        </span>
      </v-layout>
      <v-container class="px-1">
        <v-layout column>
          <!-- REQUIRED DEGREE -->
          <v-expansion-panels focusable class="px-2 ">
            <v-expansion-panel class="mt-2 ">
              <v-expansion-panel-header class="light-blue--text text--darken-4">
                <v-layout row align-center pb-0>
                  <v-icon color="blue darken-3">mdi-school</v-icon>
                  <span
                    class="ml-2 blue--text text--darken-3 font-weight-medium"
                    >Degree</span
                  >
                </v-layout>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                eager
                class=" px-0 mx-0 pb-0 elevation-0 "
              >
                <!-- Degree Information -->
                <div>
                  <v-card class="innerCardCover" flat>
                    <v-layout
                      v-if="school.bachelors_degree_required"
                      justify-center
                      class=" red pb-2  "
                    >
                      <span class="white--text text-center mt-2"
                        >Bachelor's Degree Required</span
                      >
                    </v-layout>
                    <v-layout
                      v-if="school.bachelors_degree_required === false"
                      justify-center
                      class=" grey pb-2  "
                    >
                      <span class="white--text text-center mt-2"
                        >Degree Not Required</span
                      >
                    </v-layout>
                  </v-card>

                  <!-- Degree Notes -->
                  <v-card v-if="school.degreeNotes" outlined class=" mt-4 mb-4">
                    <v-layout align-center justify-center class=" pb-1">
                      <v-icon small class="mr-2"
                        >mdi-message-text-outline</v-icon
                      >
                      <span class="font-weight-light align-center"
                        >Additional Notes
                      </span>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-text class="text-center">
                      <span>{{ school.degreeNotes }}</span>
                    </v-card-text>
                  </v-card>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Minimum GPA -->
          <v-expansion-panels focusable class="px-2">
            <v-expansion-panel class="mt-4 ">
              <v-expansion-panel-header class="light-blue--text text--darken-4">
                <v-layout row align-center>
                  <v-icon color="blue darken-3"
                    >mdi-format-annotation-plus</v-icon
                  >
                  <span
                    class="ml-2 blue--text text--darken-3 font-weight-medium"
                    >GPA</span
                  >
                </v-layout>
              </v-expansion-panel-header>
              <v-expansion-panel-content class=" px-0 mx-0 pb-0 elevation-0">
                <v-layout column>
                  <!-- GPA Values and Conditions Container -->
                  <v-card class=" mb-2 elevation-0 innerCardCover" outlined>
                    <v-layout
                      v-if="school.gpa_minimum_required === true"
                      justify-center
                      class="red pb-2"
                    >
                      <span class="white--text text-center mt-2"
                        >Minimum
                        <span v-if="school.caspa_participant">CASPA</span> GPA
                        Required
                      </span>
                    </v-layout>
                    <v-layout
                      v-if="school.gpa_minimum_required === false"
                      justify-center
                      class=" grey pb-2"
                    >
                      <span class="white--text text-center mt-2"
                        >Minimum GPA Not Required</span
                      >
                    </v-layout>

                    <v-layout
                      v-if="school.gpa_minimum_required === true"
                      mt-3
                      mb-2
                      align-center
                      justify-space-around
                    >
                      <v-layout
                        v-if="
                          school.gpa_overall_minimum === '' &&
                            school.gpa_science_minimum === '' &&
                            school.gpa_prerequisite_minimum === ''
                        "
                        align-center
                        justify-center
                        mb-2
                      >
                        <span class="grey--text">Minimum GPA Not Listed</span>
                      </v-layout>
                      <!-- Overall GPA -->
                      <v-layout
                        v-if="school.gpa_overall_minimum !== ''"
                        column
                        align-center
                      >
                        <v-progress-circular
                          :width="3"
                          size="80"
                          :value="100"
                          color="grey"
                        >
                          <span
                            class="percentageValue headline font-weight-medium red--text"
                            >{{ school.gpa_overall_minimum }}</span
                          ></v-progress-circular
                        >
                        <v-layout align-center class="mt-2">
                          <span class="font-weight-light">Overall</span>
                        </v-layout>
                      </v-layout>
                      <!-- Science GPA -->
                      <v-layout
                        v-if="school.gpa_science_minimum !== ''"
                        column
                        align-center
                      >
                        <v-progress-circular
                          :width="3"
                          size="80"
                          :value="100"
                          color="grey"
                        >
                          <span
                            class="percentageValue  headline font-weight-medium red--text"
                            >{{ school.gpa_science_minimum }}</span
                          ></v-progress-circular
                        >
                        <v-layout align-center class="mt-2">
                          <span class=" font-weight-light">Science</span>
                        </v-layout>
                      </v-layout>

                      <!-- Prerequiste GPA -->
                      <v-layout
                        v-if="school.gpa_prerequisite_minimum !== ''"
                        column
                        align-center
                      >
                        <v-progress-circular
                          :width="3"
                          size="80"
                          :value="100"
                          color="grey"
                        >
                          <span
                            class="percentageValue  headline  red--text font-weight-medium "
                            >{{ school.gpa_prerequisite_minimum }}</span
                          ></v-progress-circular
                        >
                        <v-layout align-center class="mt-2">
                          <span class=" font-weight-light">Prerequisite</span>
                        </v-layout>
                      </v-layout>
                    </v-layout>
                  </v-card>
                  <v-alert
                    dense
                    type="info"
                    v-if="!checkUserLoggedIn || !checkUserIsSubscribed"
                    class="mt-5"
                  >
                    <v-row class="d-sm-flex flex-column flex-lg-row">
                      <v-col
                        class="pt-0 grow"
                        v-if="
                          school.gpa_minimum_required &&
                            (school.caspa_participant ||
                              school.direct_school_application)
                        "
                      >
                        Do you know your CASPA GPA?
                        <span v-if="!checkUserLoggedIn"> Sign up </span>
                        <span v-else-if="!checkUserIsSubscribed">
                          Subscribe</span
                        >
                        to calculate your projected CASPA GPA from the "Grades"
                        section in your Dashboard to see if you qualify for this
                        program.
                      </v-col>
                      <v-col
                        v-if="
                          !school.gpa_minimum_required &&
                            school.caspa_participant
                        "
                        class="pt-0 grow"
                      >
                        Even though this program does not require a minimum GPA,
                        you should still know how CASPA will calculate your GPA.
                        <span v-if="!checkUserLoggedIn"> Sign up </span>
                        <span v-else-if="!checkUserIsSubscribed">
                          Subscribe</span
                        >
                        to calculate your projected CASPA GPA from the "Grades"
                        section in your Dashboard to see if you qualify for this
                        program.
                      </v-col>
                      <v-col class="shrink">
                        <v-btn v-if="!checkUserLoggedIn" to="/LoginSignupPage"
                          >Sign Up</v-btn
                        >
                        <v-btn
                          v-else-if="!checkUserIsSubscribed"
                          to="/LoginSignupPage"
                          >Subscribe</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-alert>
                  <!-- CASPA GPA Calculation CARD -->
                  <v-card
                    v-if="
                      school.caspa_calculation_method !== undefined &&
                        school.caspa_calculation_method !== null &&
                        school.caspa_calculation_method[0] !== 0
                    "
                    class="mt-4 elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout
                      v-if="school.caspa_participant"
                      justify-center
                      class=" grey lighten-3 pb-2 "
                    >
                      <span class="subtitle-1 mt-2 font-weight-regular">
                        CASPA GPA Evaluated
                      </span>
                      <v-icon
                        @click="showCaspaCalulationMethod = true;"
                        small
                        class=" ml-2"
                        >mdi-information</v-icon
                      >
                    </v-layout>
                    <v-layout
                      v-else
                      justify-center
                      class=" grey lighten-3 pb-2 "
                    >
                      <span class="subtitle-1 mt-2 font-weight-regular">
                        College GPA Evaluated
                      </span>
                    </v-layout>

                    <v-card-text class="pt-2  ">
                      <v-layout
                        v-for="calMethod in school.caspa_calculation_method"
                        :key="calMethod.index"
                        column
                        class="pl-0 ml-0 "
                      >
                        <v-layout
                          v-if="calMethod === 'overall'"
                          mt-2
                          row
                          align-center
                          justify-space-between
                          mx-0
                        >
                          <span class=" font-weight-light black--text "
                            >Overall GPA
                          </span>
                          <v-icon color="blue darken-3" class="" size="20px"
                            >mdi-check-circle</v-icon
                          >
                        </v-layout>
                        <v-divider
                          v-if="calMethod === 'overall'"
                          class="mt-2 mb-1 "
                        ></v-divider>

                        <v-layout
                          v-if="calMethod === 'science'"
                          mt-2
                          row
                          align-center
                          justify-space-between
                          mx-0
                        >
                          <span class="font-weight-light black--text"
                            >Science GPA
                          </span>
                          <v-icon color="blue darken-3" class="" size="20px"
                            >mdi-check-circle</v-icon
                          >
                        </v-layout>
                        <v-divider
                          v-if="calMethod === 'science'"
                          class="mt-2 mb-1 "
                        ></v-divider>

                        <v-layout
                          v-if="calMethod === 'last 30 credits'"
                          mt-2
                          row
                          align-center
                          justify-space-between
                          mx-0
                        >
                          <span class="font-weight-light black--text"
                            >Last 30 credits GPA
                          </span>
                          <v-icon color="blue darken-3" class="" size="20px"
                            >mdi-check-circle</v-icon
                          >
                        </v-layout>
                        <v-divider
                          v-if="calMethod === 'last 30 credits'"
                          class="mt-2 mb-1 "
                        ></v-divider>

                        <v-layout
                          v-if="calMethod === 'last 30 science credits'"
                          mt-2
                          row
                          align-center
                          justify-space-between
                          mx-0
                        >
                          <span class="black--text font-weight-light"
                            >Last 30 science credits GPA
                          </span>
                          <v-icon color="blue darken-3" class="" size="20px"
                            >mdi-check-circle</v-icon
                          >
                        </v-layout>
                        <v-divider
                          v-if="calMethod === 'last 30 science credits'"
                          class="mt-2 mb-1 "
                        ></v-divider>

                        <v-layout
                          v-if="calMethod === 'last 60 credits'"
                          mt-2
                          row
                          align-center
                          justify-space-between
                          mx-0
                        >
                          <span class="black--text font-weight-light"
                            >Last 60 credits GPA
                          </span>
                          <v-icon color="blue darken-3" class="" size="20px"
                            >mdi-check-circle</v-icon
                          >
                        </v-layout>
                        <v-divider
                          v-if="calMethod === 'last 60 credits'"
                          class="mt-2 mb-1 "
                        ></v-divider>
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <!-- DIALOG CASPA GPA CALCULATION INFO -->
                  <v-dialog
                    v-model="showCaspaCalulationMethod"
                    scrollable
                    max-width="400"
                    persistent
                    style="zIndex:2000"
                  >
                    <v-card style="borderRadius:5px">
                      <v-card-title
                        class="title grey lighten-2 text-xs-center mb-2"
                      >
                        CASPA GPA Calculation
                      </v-card-title>
                      <v-card-text class="text-xs-justify">
                        A CASPA GPA varies from the traditional GPA. PA programs
                        with minimum GPA requirements request specific GPA’s
                        calculated by CASPA. Some may require an overall GPA,
                        while others require an overall, science, and last 60
                        credits GPA. CASPA will provide the exact GPA or GPA’s
                        the PA school has set as a minimum once all of your
                        information is verified. You can read more information
                        regarding the CASPA GPA calculation formula by clicking
                        the following link.<a
                          class="ml-1"
                          href="https://help.liaisonedu.com/CASPA_Applicant_Help_Center/Submitting_and_Monitoring_Your_CASPA_Application/Verification_and_GPA_Calculations_for_CASPA/2_How_Your_GPA_is_Calculated"
                          target="_blank"
                          >CASPA GPA calculation formula.
                        </a>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          @click="showCaspaCalulationMethod = false;"
                          block
                          color="red"
                          class="elevation-0"
                          dark
                          >Close</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <!-- GPA CONDITIONS CARD -->
                  <v-card
                    v-if="
                      (school.last_30credits_science_gpa_minimum !== '' &&
                        school.last_30credits_science_gpa_minimum !==
                          undefined) ||
                        (school.last_40credits_science_gpa_minimum !== '' &&
                          school.last_40credits_science_gpa_minimum !==
                            undefined) ||
                        (school.last_45credits_gpa_minimum !== '' &&
                          school.last_45credits_gpa_minimum !== undefined) ||
                        (school.last_60credits_gpa_minimum !== '' &&
                          school.last_60credits_gpa_minimum !== undefined) ||
                        (school.gpa30_better_courses[0] !== 0 &&
                          school.gpa30_better_courses[0] !== undefined)
                    "
                    class=" mt-5 mb-2 elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout justify-center class=" grey lighten-3 pb-2 ">
                      <span block flat class="mt-2 red--text">
                        Other Required GPA Conditions
                      </span>
                    </v-layout>

                    <v-card-text class="pt-2  ">
                      <v-layout column class="pl-0 ml-0 ">
                        <!-- Science GPA Minimum for last 30 credits -->
                        <v-layout
                          v-if="
                            school.last_30credits_science_gpa_minimum !== '' &&
                              school.last_30credits_science_gpa_minimum !==
                                undefined
                          "
                          mt-2
                          row
                          align-center
                          justify-space-between
                          mx-0
                        >
                          <span class=" font-weight-light black--text "
                            >Science GPA for last
                            <span class="font-weight-regular"
                              >30 credits</span
                            ></span
                          >
                          <span
                            class="blue--text text--darken-3 font-weight-medium"
                            >{{
                              school.last_30credits_science_gpa_minimum
                            }}</span
                          >
                        </v-layout>
                        <v-divider
                          v-if="
                            school.last_30credits_science_gpa_minimum !== '' &&
                              school.last_30credits_science_gpa_minimum !==
                                undefined
                          "
                          class="mt-2 mb-1 "
                        ></v-divider>

                        <!-- Science GPA Minimum for last 40 credits -->
                        <v-layout
                          v-if="
                            school.last_40credits_science_gpa_minimum !== '' &&
                              school.last_40credits_science_gpa_minimum !==
                                undefined
                          "
                          mt-2
                          row
                          align-center
                          justify-space-between
                          mx-0
                        >
                          <span class=" font-weight-light black--text "
                            >Science GPA for last
                            <span class="font-weight-regular"
                              >40 credits</span
                            ></span
                          >
                          <span
                            class="blue--text text--darken-3 font-weight-medium"
                            >{{
                              school.last_40credits_science_gpa_minimum
                            }}</span
                          >
                        </v-layout>
                        <v-divider
                          v-if="
                            school.last_40credits_science_gpa_minimum !== '' &&
                              school.last_40credits_science_gpa_minimum !==
                                undefined
                          "
                          class="mt-2 mb-1 "
                        ></v-divider>

                        <!-- Science GPA Minimum for last 45 credits -->
                        <v-layout
                          v-if="
                            school.last_45credits_gpa_minimum !== '' &&
                              school.last_45credits_gpa_minimum !== undefined
                          "
                          mt-2
                          row
                          align-center
                          justify-space-between
                          mx-0
                        >
                          <span class=" font-weight-light black--text "
                            >Science GPA for last
                            <span class="font-weight-regular"
                              >45 credits</span
                            ></span
                          >
                          <span
                            class="blue--text text--darken-3 font-weight-medium"
                            >{{ school.last_45credits_gpa_minimum }}</span
                          >
                        </v-layout>
                        <v-divider
                          v-if="
                            school.last_45credits_gpa_minimum !== '' &&
                              school.last_45credits_gpa_minimum !== undefined
                          "
                          class="mt-2 mb-1 "
                        ></v-divider>

                        <!-- Overall GPA LAST 60 CREDITS -->
                        <v-layout
                          v-if="
                            school.last_60credits_gpa_minimum !== '' &&
                              school.last_60credits_gpa_minimum !== undefined
                          "
                          mt-2
                          row
                          align-center
                          justify-space-between
                          mx-0
                        >
                          <span class=" font-weight-light black--text "
                            >Overall GPA for last
                            <span class="font-weight-regular"
                              >60 credits</span
                            ></span
                          >
                          <span
                            class="blue--text text--darken-3 font-weight-medium"
                            >{{ school.last_60credits_gpa_minimum }}</span
                          >
                        </v-layout>
                        <v-divider
                          v-if="
                            school.last_60credits_gpa_minimum !== '' &&
                              school.last_60credits_gpa_minimum !== undefined
                          "
                          class="mt-2 mb-1 "
                        ></v-divider>

                        <!--
                          GPA of 3.0 or better needed in the following courses
                        -->
                        <v-layout
                          v-if="school.gpa30_better_courses[0] !== 0"
                          column
                          class="pb-0 "
                        >
                          <v-layout>
                            <p class=" mt-2 mb-0 font-weight-light black--text">
                              GPA of<span
                                class="font-weight-medium blue--text text--darken-3"
                              >
                                3.0 </span
                              >or better required for following prerequisites:
                            </p>
                          </v-layout>
                          <v-layout
                            column
                            v-for="course in school.gpa30_better_courses"
                            :key="course.id"
                            class="mt-1 ml-3"
                          >
                            <v-layout row align-center
                              ><span
                                class="font-weight-regular blue--text text--darken-3 "
                                >{{ course.course_name }}</span
                              >
                              <span
                                v-if="
                                  course.lab !== null &&
                                    course.lab !== undefined
                                "
                                class="caption grey--text ml-1"
                                >{{ course.lab[0] }}</span
                              >
                            </v-layout>
                            <v-layout>
                              <span
                                v-if="
                                  course.credits !== '' &&
                                    course.credits !== undefined
                                "
                                class="grey--text"
                                >{{ course.credits }} credits</span
                              >
                              <span
                                v-if="
                                  course.semester !== '' &&
                                    course.semester !== undefined
                                "
                                class="grey--text"
                              >
                                - {{ course.semester }} semester hrs</span
                              >
                              <span
                                v-if="
                                  course.quarter !== '' &&
                                    course.quarter !== undefined
                                "
                                class="grey--text"
                              >
                                - {{ course.quarter }} quarter hrs</span
                              >
                            </v-layout>
                          </v-layout>
                          <v-divider class="mt-2"></v-divider>
                        </v-layout>
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <!-- Average GPA Accepted Previous Year -->
                  <v-card
                    v-if="
                      school.gpa_overall_average_accepted_previous_year !==
                        '' ||
                        school.gpa_overall_average_accepted_previous_year !==
                          '' ||
                        school.gpa_science_average_accepted_previous_year !== ''
                    "
                    class="mt-4 mb-2 innerCardCover elevation-0"
                    outlined
                  >
                    <v-layout justify-center class=" green pb-2 ">
                      <span block flat class=" white--text mt-2"
                        >Avg. GPA Accepted Prior Cycle</span
                      >
                    </v-layout>
                    <v-layout mt-3 mb-2 align-center justify-space-around>
                      <v-layout
                        v-if="
                          school.gpa_overall_average_accepted_previous_year ===
                            '' &&
                            school.gpa_overall_average_accepted_previous_year ===
                              '' &&
                            school.gpa_science_average_accepted_previous_year ===
                              ''
                        "
                        align-center
                        justify-center
                        mb-2
                      >
                        <span class="grey--text">Not Listed</span>
                      </v-layout>
                      <!-- Overall GPA -->
                      <v-layout
                        v-if="
                          school.gpa_overall_average_accepted_previous_year !==
                            ''
                        "
                        column
                        align-center
                      >
                        <v-progress-circular
                          :width="3"
                          size="80"
                          :value="100"
                          color="grey"
                        >
                          <span
                            class="percentageValue headline font-weight-medium green--text"
                            >{{
                              school.gpa_overall_average_accepted_previous_year
                            }}</span
                          ></v-progress-circular
                        >
                        <v-layout align-center class="mt-2">
                          <span class=" font-weight-light ">Overall</span>
                        </v-layout>
                      </v-layout>
                      <!-- Science GPA -->
                      <v-layout
                        v-if="
                          school.gpa_science_average_accepted_previous_year !==
                            ''
                        "
                        column
                        align-center
                      >
                        <v-progress-circular
                          :width="3"
                          size="80"
                          :value="100"
                          color="grey"
                        >
                          <span
                            class="percentageValue  headline font-weight-medium green--text"
                            >{{
                              school.gpa_science_average_accepted_previous_year
                            }}</span
                          ></v-progress-circular
                        >
                        <v-layout align-center class="mt-2">
                          <span class="  font-weight-light ">Science</span>
                        </v-layout>
                      </v-layout>

                      <!-- Prerequiste GPA -->
                      <v-layout
                        v-if="
                          school.gpa_prerequiste_average_accepted_previous_year !==
                            '' &&
                            school.gpa_prerequiste_average_accepted_previous_year !==
                              undefined
                        "
                        column
                        align-center
                      >
                        <v-progress-circular
                          :width="3"
                          size="80"
                          :value="100"
                          color="grey"
                        >
                          <span
                            class="percentageValue  headline  green--text font-weight-medium "
                            >{{
                              school.gpa_prerequiste_average_accepted_previous_year
                            }}</span
                          ></v-progress-circular
                        >
                        <v-layout align-center class="mt-2">
                          <span class=" font-weight-light ">Prerequisite</span>
                        </v-layout>
                      </v-layout>
                    </v-layout>
                  </v-card>

                  <!-- GPA Notes -->
                  <v-card v-if="school.gpaNotes" outlined class=" mt-4 mb-4">
                    <v-layout align-center justify-center class=" pb-1">
                      <v-icon small class="mr-2"
                        >mdi-message-text-outline</v-icon
                      >
                      <span class="font-weight-light align-center">
                        Additional Notes
                      </span>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-text class="text-center">
                      <span>{{ school.gpaNotes }}</span>
                    </v-card-text>
                  </v-card>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Prerequiste Courses -->
          <v-expansion-panels focusable class="px-2">
            <v-expansion-panel class="mt-4">
              <v-expansion-panel-header class="light-blue--text text--darken-4">
                <v-layout row align-center>
                  <v-icon color="blue darken-3">mdi-text-box-multiple</v-icon>
                  <span
                    class="ml-2 blue--text text--darken-3 font-weight-medium"
                    >Prerequisites</span
                  >
                </v-layout>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="px-0 mx-0 pb-0 elevation-0">
                <v-container class="pa-0">
                  <!-- Required Prerequistes -->
                  <v-card
                    v-if="
                      school.required_courses[0] === 0 &&
                        school.optional_courses_group[0] === 0 &&
                        school.required_category_courses[0] === 0
                    "
                    flat
                  >
                    <v-card-text class="px-0 pt-3 pb-1 text-center">
                      <span
                        >Please visit the school website for prerequisite
                        details</span
                      >
                    </v-card-text>
                  </v-card>

                  <v-card
                    v-if="
                      school.required_courses[0] !== 0 ||
                        school.optional_courses_group[0] !== 0 ||
                        school.required_category_courses[0] !== 0
                    "
                    class="pb-4 elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout justify-center class="red pb-2">
                      <span class="white--text text-center mt-2"
                        >Required Prerequisites</span
                      >
                    </v-layout>

                    <v-card-text class="px-0 pt-0 pb-1">
                      <!-- Courses -->
                      <v-expansion-panels
                        v-if="school.required_courses[0] !== 0"
                        class="px-2 elevation-0"
                      >
                        <v-expansion-panel class="mt-3 elevation-0">
                          <v-expansion-panel-header class="elevation-0">
                            <v-layout row align-center>
                              <span class="">Courses</span>
                              <span
                                class="caption font-weight-light ml-1 red--text"
                                >( {{ school.required_courses.length }} )</span
                              >
                            </v-layout>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content id="secondaryButtonShadow">
                            <v-container pt-0 px-0 pb-0>
                              <v-list two-line class="pt-0 pb-0">
                                <v-list-item-group>
                                  <template
                                    v-for="(requiredCourse,
                                    index) in school.required_courses"
                                  >
                                    <v-list-item
                                      :key="requiredCourse.id"
                                      class="pl-3 "
                                    >
                                      <v-list-item-content class="py-2">
                                        <v-list-item-title
                                          class="light-blue--text text--darken-3"
                                        >
                                          <v-layout align-center
                                            >{{ requiredCourse.course_name }}
                                          </v-layout>
                                        </v-list-item-title>
                                        <v-list-item-subtitle
                                          v-if="
                                            requiredCourse.lab[0] !== 'N/A' &&
                                              requiredCourse.lab !==
                                                undefined &&
                                              requiredCourse.lab !== null
                                          "
                                          class="text--primary font-weight-light"
                                        >
                                          <span class=""
                                            >{{ requiredCourse.lab[0] }}
                                          </span>
                                        </v-list-item-subtitle>

                                        <v-list-item-subtitle
                                          v-if="
                                            (requiredCourse.credits !== '' &&
                                              requiredCourse.credits !==
                                                undefined) ||
                                              (requiredCourse.semester !== '' &&
                                                requiredCourse.semester !==
                                                  undefined)
                                          "
                                          class="text--primary font-weight-light"
                                        >
                                          <span
                                            v-if="requiredCourse.credits !== ''"
                                            >{{
                                              requiredCourse.credits
                                            }}
                                            credits
                                            <span
                                              v-if="
                                                requiredCourse.semester !==
                                                  '' &&
                                                  requiredCourse.semester !==
                                                    undefined
                                              "
                                              >or</span
                                            ></span
                                          >
                                          <span
                                            v-if="
                                              requiredCourse.semester !== '' &&
                                                requiredCourse.semester !==
                                                  undefined
                                            "
                                          >
                                            {{
                                              requiredCourse.semester
                                            }}
                                            semester hrs</span
                                          >
                                          <span
                                            v-if="
                                              requiredCourse.quarter !== '' &&
                                                requiredCourse.quarter !==
                                                  undefined
                                            "
                                          >
                                            or
                                            {{ requiredCourse.quarter }} quarter
                                            hrs</span
                                          >
                                        </v-list-item-subtitle>
                                      </v-list-item-content>
                                    </v-list-item>

                                    <v-divider
                                      v-if="
                                        index + 1 <
                                          school.required_courses.length
                                      "
                                      :key="index"
                                      class="my-0 py-0"
                                    ></v-divider>
                                  </template>
                                </v-list-item-group>
                              </v-list>
                            </v-container>
                          </v-expansion-panel-content>

                          <p
                            v-if="
                              school.recommended_courses[0] === 0 &&
                                school.required_courses[0] === 0
                            "
                            class="blue--text caption "
                          >
                            No Courses Listed
                          </p>
                        </v-expansion-panel>
                      </v-expansion-panels>

                      <!-- Optional Courses -->
                      <v-expansion-panels
                        v-if="school.optional_courses_group[0] !== 0"
                        class="mt-2 px-2"
                      >
                        <v-expansion-panel class="mt-3 ">
                          <v-expansion-panel-header>
                            <v-layout row align-center>
                              <span class="">Either Course(s) Required</span>
                              <span
                                class="caption font-weight-light ml-1 red--text"
                                >(
                                {{
                                  school.optional_courses_group.length
                                }}
                                )</span
                              >
                            </v-layout>
                          </v-expansion-panel-header>

                          <v-expansion-panel-content id="secondaryButtonShadow">
                            <v-card
                              v-for="(optionalCourse,
                              index) in school.optional_courses_group"
                              :key="optionalCourse.id"
                              class=" mb-3 elevation-0 innerCardCover"
                              style="borderRadius:5px"
                              outlined
                            >
                              <v-layout class=" pl-4 pb-1 mt-2">
                                <span class="mt-2 red--text body-2">
                                  {{
                                    optionalCourse.mininum_courses_completed
                                  }}
                                  of the following course(s) need to be
                                  completed
                                </span>
                              </v-layout>
                              <v-card-text pt-2 class="pt-0 pb-0">
                                <v-list two-line class="pt-0 pb-0">
                                  <v-list-item-group>
                                    <template
                                      v-for="(course,
                                      index) in optionalCourse.options"
                                    >
                                      <v-list-item
                                        :key="course.id"
                                        class="pl-0 pt-0"
                                      >
                                        <v-list-item-content>
                                          <v-list-item-title
                                            class="light-blue--text text--darken-3"
                                          >
                                            <v-layout align-center
                                              >{{ course.course_name }}
                                            </v-layout>
                                          </v-list-item-title>
                                          <v-list-item-subtitle
                                            v-if="
                                              course.lab !== null &&
                                                course.lab !== undefined
                                            "
                                            class="text--primary font-weight-light"
                                          >
                                            <span class=""
                                              >{{ course.lab[0] }}
                                            </span>
                                          </v-list-item-subtitle>

                                          <v-list-item-subtitle
                                            v-if="
                                              course.credits !== '' &&
                                                course.credits !== undefined
                                            "
                                            class="text--primary font-weight-light"
                                          >
                                            <span
                                              >{{ course.credits }} credits
                                              <span
                                                v-if="
                                                  course.semester !== '' &&
                                                    course.semester !==
                                                      undefined
                                                "
                                                >or</span
                                              ></span
                                            >
                                            <span
                                              v-if="
                                                course.semester !== '' &&
                                                  course.semester !== undefined
                                              "
                                            >
                                              {{ course.semester }} semester
                                              hrs</span
                                            >
                                            <span
                                              v-if="
                                                course.quarter !== '' &&
                                                  course.quarter !== undefined
                                              "
                                            >
                                              or {{ course.quarter }} quarter
                                              hrs</span
                                            >
                                          </v-list-item-subtitle>
                                        </v-list-item-content>
                                      </v-list-item>

                                      <v-divider
                                        v-if="
                                          index + 1 <
                                            optionalCourse.options.length
                                        "
                                        :key="index"
                                      ></v-divider>
                                    </template>
                                  </v-list-item-group>
                                </v-list>
                              </v-card-text>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>

                      <!-- Course Category -->
                      <v-expansion-panels
                        v-if="school.required_category_courses[0] !== 0"
                        class="mt-2 px-2"
                      >
                        <v-expansion-panel class="mt-3 ">
                          <v-expansion-panel-header>
                            <v-layout row align-center>
                              <span class="">Required Category</span>
                              <span
                                class="caption font-weight-light ml-1 red--text"
                                >(
                                {{
                                  school.required_category_courses.length
                                }}
                                )</span
                              >
                            </v-layout>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content id="secondaryButtonShadow">
                            <v-card
                              v-for="requiredCourseCategory in school.required_category_courses"
                              :key="requiredCourseCategory.id"
                              class="mb-3 elevation-0 innerCardCover"
                              style="borderRadius:5px"
                              outlined
                            >
                              <v-card-title class="pa-0">
                                <v-layout class="" align-center>
                                  <v-layout class="">
                                    <p class="subtitle-1  red--text ml-2 mb-0">
                                      {{
                                        requiredCourseCategory.category
                                          .category_name
                                      }}
                                    </p>
                                  </v-layout>
                                </v-layout>
                              </v-card-title>
                              <v-divider class="mt-1 mb-1"></v-divider>
                              <!-- CATEGORY CONDITIONS -->
                              <v-container class="pt-2 pb-2 pl-2">
                                <!-- TOTAL CREDITS COMPLETED -->
                                <v-layout
                                  v-if="
                                    (requiredCourseCategory.total_credits_completed !==
                                      '' &&
                                      requiredCourseCategory.total_credits_completed !==
                                        undefined &&
                                      requiredCourseCategory.number_of_courses_completed ===
                                        '') ||
                                      (requiredCourseCategory.number_of_courses_completed ===
                                        undefined &&
                                        school.maximum_outstanding_courses_while_applying ===
                                          '' &&
                                        school.maximum_outstanding_courses_while_applying ===
                                          undefined)
                                  "
                                >
                                  <span class="font-weight-light"
                                    ><span
                                      class="font-weight-regular light-blue--text text--darken-3"
                                      >{{
                                        requiredCourseCategory.total_credits_completed
                                      }}
                                      credits</span
                                    >
                                    of
                                    {{
                                      requiredCourseCategory.category
                                        .category_name
                                    }}
                                    need to be completed</span
                                  >
                                </v-layout>
                                <v-divider
                                  v-if="
                                    requiredCourseCategory.total_credits_completed !==
                                      '' &&
                                      requiredCourseCategory.total_credits_completed !==
                                        undefined &&
                                      requiredCourseCategory.number_of_courses_completed ===
                                        '' &&
                                      requiredCourseCategory.number_of_courses_completed ===
                                        undefined &&
                                      school.maximum_outstanding_courses_while_applying !==
                                        '' &&
                                      school.maximum_outstanding_courses_while_applying !==
                                        undefined
                                  "
                                  class="mt-1 mb-1"
                                ></v-divider>

                                <!-- TOTAL # OF COURSES COMPLETED -->
                                <v-layout
                                  v-if="
                                    requiredCourseCategory.number_of_courses_completed !==
                                      '' &&
                                      requiredCourseCategory.number_of_courses_completed !==
                                        undefined
                                  "
                                >
                                  <span class="font-weight-light"
                                    ><span
                                      class="font-weight-regular  light-blue--text text--darken-3"
                                      >{{
                                        requiredCourseCategory.number_of_courses_completed
                                      }}
                                      course(s)</span
                                    >
                                    of
                                    {{
                                      requiredCourseCategory.category
                                        .category_name
                                    }}
                                    need to be completed</span
                                  >
                                </v-layout>
                                <v-divider
                                  v-if="
                                    requiredCourseCategory.number_of_courses_completed !==
                                      '' &&
                                      requiredCourseCategory.number_of_courses_completed !==
                                        undefined
                                  "
                                  class="mt-1"
                                ></v-divider>

                                <!-- # OF COURSES COMPLETED WITH LAB -->
                                <v-layout
                                  v-if="
                                    requiredCourseCategory.courses_required_with_lab !==
                                      '' &&
                                      requiredCourseCategory.courses_required_with_lab !==
                                        undefined
                                  "
                                >
                                  <span class="font-weight-light"
                                    ><span
                                      class="font-weight-regular  light-blue--text text--darken-3"
                                      >{{
                                        requiredCourseCategory.courses_required_with_lab
                                      }}
                                      course(s)</span
                                    >
                                    of
                                    {{
                                      requiredCourseCategory.category
                                        .category_name
                                    }}
                                    need to be completed with
                                    <span
                                      class="font-weight-bold grey--text text--darken-3"
                                      >lab</span
                                    ></span
                                  >
                                </v-layout>
                                <v-divider
                                  v-if="
                                    requiredCourseCategory.courses_required_with_lab !==
                                      '' &&
                                      requiredCourseCategory.courses_required_with_lab !==
                                        undefined
                                  "
                                  class="mt-1"
                                ></v-divider>
                              </v-container>
                              <v-card-actions class="py-1 ">
                                <v-btn
                                  block
                                  class="elevation-0"
                                  color="primary"
                                  dark
                                  @click="
                                    requiredCourseCategoryDialog(
                                      requiredCourseCategory
                                    );
                                  "
                                >
                                  View Courses
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <!-- Course Category Dialog -->
                        <v-dialog
                          v-model="showCoursesCategory"
                          scrollable
                          max-width="400"
                          height="100"
                          style="zIndex:2000"
                          persistent
                        >
                          <v-card
                            v-if="
                              loadedCategory !== null &&
                                loadedCategory.excluded_courses === undefined
                            "
                            style="borderRadius:10px"
                          >
                            <v-card-title
                              class="title grey lighten-2 text-xs-center"
                            >
                              {{ loadedCategory.category.category_name }}
                              <v-spacer></v-spacer>
                              <v-icon @click="showCoursesCategory = false;"
                                >mdi-close</v-icon
                              >
                            </v-card-title>

                            <v-card-text class="text-xs-justify mt-2">
                              <v-layout
                                v-for="course in loadedCategory.category
                                  .courses"
                                :key="course.id"
                              >
                                <span class="primary--text">{{
                                  course.course_name
                                }}</span>
                              </v-layout>
                              <v-layout
                                v-if="
                                  loadedCategory.included_courses.length >= 1
                                "
                                v-for="course in showCoursesCategory.included_courses"
                                :key="course.id"
                              >
                                <span class="primary--text">{{
                                  course.course_name
                                }}</span>
                              </v-layout>
                            </v-card-text>
                          </v-card>

                          <!--
                            <v-card  v-if="loadedCategory !== null && loadedCategory.excluded_courses === undefined " style="borderRadius:10px">
                                <v-card-title class="title grey lighten-2 text-xs-center">
                                  {{loadedCategory.category.category_name}} Courses
                                <v-spacer></v-spacer>
                                <v-icon @click="showCoursesCategory = null">mdi-close</v-icon>
                                </v-card-title>



                                        <v-card-text class="text-xs-justify" >
                                          <v-layout v-for="course in showCoursesCategory.category.courses" :key="course.id">
                                            <span>{{course.course_name}}</span>
                                          </v-layout>
                                          <v-layout v-if="showCoursesCategory.included_courses.length >= 1" v-for="course in showCoursesCategory.included_courses" :key="course.id">
                                            <span>{{course.course_name}}</span>
                                          </v-layout>
                                        </v-card-text>


                                  </v-tabs>

                            </v-card>
                          -->

                          <v-card
                            v-if="
                              loadedCategory !== null &&
                                loadedCategory.excluded_courses !== undefined
                            "
                            style="borderRadius:10px"
                          >
                            <v-card-title
                              class="title grey lighten-2 text-xs-center"
                            >
                              {{ loadedCategory.category.category_name }}
                              <v-spacer></v-spacer>
                              <v-icon @click="showCoursesCategory = false;"
                                >mdi-close</v-icon
                              >
                            </v-card-title>

                            <v-tabs grow fixed class="px-3 mt-4">
                              <v-tab
                                active-class="grey darken-3 white--text"
                                style="marginLeft:0px;"
                              >
                                Courses
                              </v-tab>

                              <v-tab
                                v-if="
                                  loadedCategory.excluded_courses !==
                                    undefined &&
                                    loadedCategory.excluded_courses.length >= 1
                                "
                                active-class="grey darken-3 white--text"
                              >
                                Excluded Courses
                              </v-tab>

                              <v-tab-item>
                                <v-card-text class="text-xs-justify">
                                  <v-layout
                                    v-for="course in loadedCategory.category
                                      .courses"
                                    :key="course.id"
                                  >
                                    <span class="primary--text">{{
                                      course.course_name
                                    }}</span>
                                  </v-layout>
                                  <v-layout
                                    v-if="
                                      showCoursesCategory.included_courses
                                        .length >= 1
                                    "
                                    v-for="course in showCoursesCategory.included_courses"
                                    :key="course.id"
                                  >
                                    <span class="primary--text">{{
                                      course.course_name
                                    }}</span>
                                  </v-layout>
                                </v-card-text>
                              </v-tab-item>
                              <v-tab-item>
                                <v-layout
                                  v-if="
                                    loadedCategory.excluded_courses.length >= 1
                                  "
                                  v-for="course in loadedCategory.excluded_courses"
                                  :key="course.id"
                                >
                                  <v-card-text class="text-xs-justify">
                                    <span class="red--text">{{
                                      course.course_name
                                    }}</span>
                                  </v-card-text>
                                </v-layout>
                              </v-tab-item>
                            </v-tabs>
                          </v-card>
                        </v-dialog>
                      </v-expansion-panels>
                    </v-card-text>
                  </v-card>

                  <v-alert
                    type="info"
                    v-if="!checkUserLoggedIn || !checkUserIsSubscribed"
                    class="mt-5"
                  >
                    <v-row
                      class="d-sm-flex flex-column flex-lg-row"
                      v-if="
                        school.required_courses[0] !== 0 ||
                          school.optional_courses_group[0] !== 0 ||
                          school.required_category_courses[0] !== 0
                      "
                    >
                      <v-col class="grow pt-0">
                        <span v-if="!checkUserLoggedIn"> Sign up </span>
                        <span v-else-if="!checkUserIsSubscribed">
                          Subscribe</span
                        >
                        to keep track of all your prerequisites in the "Grades"
                        section of your dashboard to see if you qualify for this
                        program.
                      </v-col>

                      <v-col class="shrink">
                        <v-btn v-if="!checkUserLoggedIn" to="/LoginSignupPage"
                          >Sign Up</v-btn
                        >
                        <v-btn
                          v-else-if="!checkUserIsSubscribed"
                          to="/LoginSignupPage"
                          >Subscribe</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-alert>

                  <!-- Recommended Prerequistes -->
                  <v-card
                    v-if="school.recommended_courses[0] !== 0"
                    class="pb-3 mt-3 elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout justify-center class="amber darken-3 pb-2">
                      <span class="white--text text-center mt-2"
                        >Recommended Prerequisites</span
                      >
                    </v-layout>

                    <!-- Recommended Courses -->
                    <v-expansion-panels
                      v-if="school.recommended_courses[0] !== 0"
                      class="px-2"
                    >
                      <v-expansion-panel class="mt-3 ">
                        <v-expansion-panel-header>
                          <v-layout row align-center>
                            <span class="">Courses</span>
                            <span
                              class="caption font-weight-light ml-1 amber--text text--darken-4"
                              >( {{ school.recommended_courses.length }} )</span
                            >
                          </v-layout>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content id="secondaryButtonShadow">
                          <v-container pt-0 pb-0>
                            <v-list two-line class="pt-0">
                              <v-list-item-group>
                                <template
                                  v-for="(recommendedCourse,
                                  index) in school.recommended_courses"
                                >
                                  <v-list-item
                                    :key="recommendedCourse.id"
                                    class="pl-0 pt-1"
                                  >
                                    <v-list-item-content>
                                      <v-list-item-title
                                        class="light-blue--text text--darken-3"
                                      >
                                        <v-layout align-center
                                          >{{ recommendedCourse.course_name }}
                                        </v-layout>
                                      </v-list-item-title>
                                      <v-list-item-subtitle
                                        v-if="
                                          Array.isArray(recommendedCourse.lab)
                                        "
                                        class="text--primary font-weight-light"
                                      >
                                        <span class=""
                                          >{{ recommendedCourse.lab[0] }}
                                        </span>
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle
                                        v-else
                                        class="text--primary font-weight-light"
                                      >
                                        <span class="">
                                          {{ recommendedCourse.lab }}
                                        </span>
                                      </v-list-item-subtitle>

                                      <v-list-item-subtitle
                                        v-if="
                                          recommendedCourse.credits !== '' &&
                                            recommendedCourse.credits !==
                                              undefined
                                        "
                                        class="text--primary font-weight-light"
                                      >
                                        <span
                                          >{{
                                            recommendedCourse.credits
                                          }}
                                          credits
                                          <span
                                            v-if="
                                              recommendedCourse.semester !==
                                                '' &&
                                                recommendedCourse.semester !==
                                                  undefined
                                            "
                                            >or</span
                                          ></span
                                        >
                                        <span
                                          v-if="
                                            recommendedCourse.semester !== '' &&
                                              recommendedCourse.semester !==
                                                undefined
                                          "
                                        >
                                          {{
                                            recommendedCourse.semester
                                          }}
                                          semester hrs</span
                                        >
                                        <span
                                          v-if="
                                            recommendedCourse.quarter !== '' &&
                                              recommendedCourse.quarter !==
                                                undefined
                                          "
                                        >
                                          or
                                          {{
                                            recommendedCourse.quarter
                                          }}
                                          quarter hrs</span
                                        >
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>

                                  <v-divider
                                    v-if="
                                      index + 1 <
                                        school.recommended_courses.length
                                    "
                                    :key="index"
                                  ></v-divider>
                                </template>
                              </v-list-item-group>
                            </v-list>
                          </v-container>
                        </v-expansion-panel-content>

                        <p
                          v-if="
                            school.recommended_courses[0] === 0 &&
                              school.required_courses[0] === 0
                          "
                          class="blue--text caption "
                        >
                          No Courses Listed
                        </p>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card>

                  <!-- Prerequisites CONDITION CARD -->
                  <v-card
                    v-if="
                      school.required_courses[0] !== 0 ||
                        school.optional_courses_group[0] !== 0 ||
                        school.required_category_courses[0] !== 0
                    "
                    class=" mt-8 mb-3 pb-2 elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout justify-center class=" grey lighten-3 pb-2 ">
                      <span block flat class="mt-2">
                        Prerequisite Conditions
                      </span>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-text class="pt-1 px-2 pb-1">
                      <!-- Grade Conditions -->
                      <v-card
                        v-if="
                          (school.minimum_grade_course !== '' &&
                            school.minimum_grade_course !== undefined) ||
                            (school.recommended_grade_course !== '' &&
                              school.recommended_grade_course !== undefined) ||
                            (school.nomore_1_grade_below_b_minus === true &&
                              school.nomore_1_grade_below_b_minus !==
                                undefined) ||
                            (school.nomore_2_grades_below_c !== '' &&
                              school.nomore_2_grades_below_c !== undefined) ||
                            (school.maximum_grades_below_c_minus !== '' &&
                              school.maximum_grades_below_c_minus !==
                                undefined) ||
                            school
                              .minimumGrade_C_required_specific_courses[0] !== 0
                        "
                        class=" mt-4  mb-3 elevation-0"
                        style="borderRadius:5px"
                        id="borderCard"
                      >
                        <v-layout class="  pb-2 pt-2 red justify-center">
                          <span
                            block
                            flat
                            class=" white--text font-weight-medium "
                          >
                            Grade Conditions
                          </span>
                        </v-layout>
                        <v-card-text class="pt-2 pb-1">
                          <!-- MINIMUM GRADE REQUIRED FOR prerequisites -->
                          <v-layout
                            v-if="
                              school.minimum_grade_course !== '' &&
                                school.minimum_grade_course !== undefined
                            "
                          >
                            <span class="font-weight-light black--text">
                              Minimum grade of
                              <span
                                class="font-weight-medium blue--text text--darken-3"
                                >{{ school.minimum_grade_course }}</span
                              >
                              required for all prerequisites</span
                            >
                          </v-layout>

                          <v-divider
                            v-if="
                              school.minimum_grade_course !== '' &&
                                school.minimum_grade_course !== undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!-- MINIMUM GRADE RECOMMENDED FOR prerequisites -->
                          <v-layout
                            v-if="
                              school.recommended_grade_course !== '' &&
                                school.recommended_grade_course !== undefined
                            "
                          >
                            <span class="font-weight-light black--text">
                              Minimum grade of
                              <span
                                class="font-weight-medium blue--text text--darken-3"
                                >{{ school.recommended_grade_course }}</span
                              >
                              recommended for all prerequisites</span
                            >
                          </v-layout>

                          <v-divider
                            v-if="
                              school.recommended_grade_course !== '' &&
                                school.recommended_grade_course !== undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            ONLY 1 PREREQUISTE COURSE BELOW GRADE B- ACCEPTED
                          -->
                          <v-layout
                            v-if="
                              school.nomore_1_grade_below_b_minus === true &&
                                school.nomore_1_grade_below_b_minus !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text">
                              Maximum of
                              <span
                                class="font-weight-medium blue--text text--darken-3"
                                >1</span
                              >
                              prerequisite(s) accepted below
                              <span
                                class="font-weight-medium blue--text text--darken-3"
                                >B-
                              </span>
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.nomore_1_grade_below_b_minus === true &&
                                school.nomore_1_grade_below_b_minus !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!-- MAXIMUM # OF prerequisites WITH GRADE C -->
                          <v-layout
                            v-if="
                              school.nomore_2_grades_below_c !== '' &&
                                school.nomore_2_grades_below_c !== undefined
                            "
                          >
                            <span class="font-weight-light black--text">
                              Maximum of
                              <span
                                class="font-weight-medium blue--text text--darken-3"
                                >{{ school.nomore_2_grades_below_c }}</span
                              >
                              prerequisites accepted with grade
                              <span
                                class="font-weight-medium blue--text text--darken-3"
                                >C</span
                              >
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.nomore_2_grades_below_c !== '' &&
                                school.nomore_2_grades_below_c !== undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!-- MAXIMUM # OF COURSES WITH GRADE C- OR BELOW -->
                          <v-layout
                            v-if="
                              school.maximum_grades_below_c_minus !== '' &&
                                school.maximum_grades_below_c_minus !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text">
                              Maximum of
                              <span
                                class="font-weight-medium blue--text text--darken-3"
                                >{{ school.maximum_grades_below_c_minus }}</span
                              >
                              courses accepted with grade
                              <span
                                class="font-weight-medium blue--text text--darken-3"
                                >C-</span
                              >
                              or below
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.maximum_grades_below_c_minus !== '' &&
                                school.maximum_grades_below_c_minus !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            MINIMUM GRADE OF C REQUIRED FOR FOLLOWING prerequisites
                          -->
                          <v-layout
                            v-if="
                              school
                                .minimumGrade_C_required_specific_courses[0] !==
                                0
                            "
                            column
                            class="pb-2 mt-2 "
                          >
                            <v-layout>
                              <p
                                class="font-weight-light mt-2 mb-0 black--text"
                              >
                                Minimum grade of
                                <span
                                  class="font-weight-medium blue--text text--darken-3"
                                  >C </span
                                >required for the following prerequisites:
                              </p>
                            </v-layout>
                            <v-layout
                              column
                              v-for="course in school.minimumGrade_C_required_specific_courses"
                              :key="course.id"
                              class="mt-3 "
                            >
                              <v-layout row align-center pl-3
                                ><span class=" blue--text text--darken-3 ">{{
                                  course.course_name
                                }}</span>
                                <span
                                  v-if="
                                    course.lab !== null &&
                                      course.lab !== undefined
                                  "
                                  class="caption grey--text ml-1"
                                  >{{ course.lab[0] }}</span
                                >
                              </v-layout>
                              <v-layout>
                                <span
                                  v-if="
                                    course.credits !== '' &&
                                      course.credits !== undefined
                                  "
                                  class="grey--text"
                                  >{{ course.credits }} credits</span
                                >
                                <span
                                  v-if="
                                    course.semester !== '' &&
                                      course.semester !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.semester }} semester hrs</span
                                >
                                <span
                                  v-if="
                                    course.quarter !== '' &&
                                      course.quarter !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.quarter }} quarter hrs</span
                                >
                              </v-layout>
                              <v-divider class="mt-2"></v-divider>
                            </v-layout>
                          </v-layout>
                        </v-card-text>
                      </v-card>

                      <!-- TIME FRAME CONDITIONS -->
                      <v-card
                        v-if="
                          (school.maximum_years_courses_completed !== '' &&
                            school.maximum_years_courses_completed !==
                              undefined) ||
                            (school.maximum_years_science_courses_completed !==
                              '' &&
                              school.maximum_years_science_courses_completed !==
                                undefined) ||
                            (school.maximum_years_math_courses_completed !==
                              '' &&
                              school.maximum_years_math_courses_completed !==
                                undefined) ||
                            (school.number_of_credits_completed_within_3_years !==
                              '' &&
                              school.number_of_credits_completed_within_3_years !==
                                undefined) ||
                            (school.number_of_credits_completed_within_5_years !==
                              '' &&
                              school.number_of_credits_completed_within_5_years !==
                                undefined) ||
                            (school.number_of_credits_completed_within_10_years !==
                              '' &&
                              school.number_of_credits_completed_within_10_years !==
                                undefined) ||
                            school
                              .specific_classes_completed_within_3years[0] !==
                              0 ||
                            school
                              .specific_classes_completed_within_5years[0] !==
                              0 ||
                            school
                              .specific_classes_completed_within_7years[0] !==
                              0 ||
                            school
                              .specific_classes_completed_within_8years[0] !==
                              0 ||
                            school
                              .specific_classes_completed_within_10years[0] !==
                              0 ||
                            (school.no_courses_5years_unless_healthcare_experience &&
                              school.no_courses_5years_unless_healthcare_experience !==
                                undefined) ||
                            (school.preference_completed_courses_within_5years !==
                              '' &&
                              school.preference_completed_courses_within_5years !==
                                undefined)
                        "
                        class=" mt-4  mb-3 elevation-0"
                        style="borderRadius:5px"
                        id="borderCard"
                      >
                        <v-layout class="  pb-2 pt-2 red justify-center">
                          <span
                            block
                            flat
                            class=" white--text font-weight-medium"
                          >
                            Timeframe Conditions
                          </span>
                        </v-layout>
                        <v-card-text class="pt-2">
                          <!-- All prerequisites must be completed within -->
                          <v-layout
                            v-if="
                              school.maximum_years_courses_completed !== '' &&
                                school.maximum_years_courses_completed !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text">
                              All prerequisites must be completed within
                              <span
                                class="font-weight-medium blue--text text--darken-3"
                              >
                                {{
                                  school.maximum_years_courses_completed
                                }}
                                year(s)</span
                              >
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.maximum_years_courses_completed !== '' &&
                                school.maximum_years_courses_completed !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            SCIENCE prerequisites must be completed within
                          -->
                          <v-layout
                            v-if="
                              school.maximum_years_science_courses_completed !==
                                '' &&
                                school.maximum_years_science_courses_completed !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text">
                              Science prerequisites must be completed within
                              <span
                                class="font-weight-medium blue--text text--darken-3"
                              >
                                {{
                                  school.maximum_years_science_courses_completed
                                }}
                                year(s)</span
                              >
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.maximum_years_science_courses_completed !==
                                '' &&
                                school.maximum_years_science_courses_completed !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!-- MATH prerequisites must be completed within -->
                          <v-layout
                            v-if="
                              school.maximum_years_math_courses_completed !==
                                '' &&
                                school.maximum_years_math_courses_completed !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text">
                              Math prerequisites must be completed within
                              <span
                                class="font-weight-medium blue--text text--darken-3"
                              >
                                {{
                                  school.maximum_years_math_courses_completed
                                }}
                                year(s)</span
                              >
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.maximum_years_math_courses_completed !==
                                '' &&
                                school.maximum_years_math_courses_completed !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!-- x credits need to be completed within 3 YEARS -->
                          <v-layout
                            v-if="
                              school.number_of_credits_completed_within_3_years !==
                                '' &&
                                school.number_of_credits_completed_within_3_years !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text">
                              <span
                                class="font-weight-bold grey--text text--darken-2"
                              >
                                {{
                                  school.number_of_credits_completed_within_3_years
                                }}
                                credits
                              </span>
                              need to be completed within
                              <span
                                class="font-weight-medium blue--text text--darken-3"
                                >3 years</span
                              >
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.number_of_credits_completed_within_3_years !==
                                '' &&
                                school.number_of_credits_completed_within_3_years !==
                                  undefined
                            "
                            class="mt-2 mb-2"
                          ></v-divider>

                          <!-- x credits need to be completed within 5 YEARS -->
                          <v-layout
                            v-if="
                              school.number_of_credits_completed_within_5_years !==
                                '' &&
                                school.number_of_credits_completed_within_5_years !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text">
                              <span
                                class="font-weight-bold grey--text text--darken-2"
                              >
                                {{
                                  school.number_of_credits_completed_within_5_years
                                }}
                                credits
                              </span>
                              need to be completed within
                              <span
                                class="font-weight-medium blue--text text--darken-3"
                              >
                                5 years</span
                              >
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.number_of_credits_completed_within_5_years !==
                                '' &&
                                school.number_of_credits_completed_within_5_years !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            x credits need to be completed within 10 YEARS
                          -->
                          <v-layout
                            v-if="
                              school.number_of_credits_completed_within_10_years !==
                                '' &&
                                school.number_of_credits_completed_within_10_years !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text">
                              <span
                                class="font-weight-bold grey--text text--darken-2"
                              >
                                {{
                                  school.number_of_credits_completed_within_10_years
                                }}
                                credits
                              </span>
                              need to be completed within
                              <span
                                class="font-weight-medium blue--text text--darken-3"
                              >
                                10 years</span
                              >
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.number_of_credits_completed_within_10_years !==
                                '' &&
                                school.number_of_credits_completed_within_10_years !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            Specific courses that need to be completed within 3 years
                          -->
                          <v-layout
                            v-if="
                              school
                                .specific_classes_completed_within_3years[0] !==
                                0
                            "
                            column
                            class="pb-2 mt-1 "
                          >
                            <v-layout>
                              <p
                                class="font-weight-light black--text mt-2 mb-0 "
                              >
                                Following prerequisites must be completed within
                                <span
                                  class="font-weight-medium blue--text text--darken-3"
                                  >3 years:
                                </span>
                              </p>
                            </v-layout>
                            <v-layout
                              column
                              v-for="course in school.specific_classes_completed_within_3years"
                              :key="course.id"
                              class="mt-3"
                            >
                              <v-layout row align-center pl-3
                                ><span class=" blue--text text--darken-3 ">{{
                                  course.course_name
                                }}</span>
                                <span
                                  v-if="
                                    course.lab !== null &&
                                      course.lab !== undefined
                                  "
                                  class="caption grey--text ml-1"
                                  >{{ course.lab[0] }}</span
                                >
                              </v-layout>
                              <v-layout>
                                <span
                                  v-if="
                                    course.credits !== '' &&
                                      course.credits !== undefined
                                  "
                                  class="grey--text"
                                  >{{ course.credits }} credits</span
                                >
                                <span
                                  v-if="
                                    course.semester !== '' &&
                                      course.semester !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.semester }} semester hrs</span
                                >
                                <span
                                  v-if="
                                    course.quarter !== '' &&
                                      course.quarter !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.quarter }} quarter hrs</span
                                >
                              </v-layout>
                              <v-divider class="mt-2"></v-divider>
                            </v-layout>
                          </v-layout>

                          <!--
                            Specific courses that need to be completed within 5 years
                          -->
                          <v-layout
                            v-if="
                              school
                                .specific_classes_completed_within_5years[0] !==
                                0
                            "
                            column
                            class="pb-2 mt-1 "
                          >
                            <v-layout>
                              <p
                                class="font-weight-light black--text mt-1 mb-0 "
                              >
                                Following prerequisites must be completed within
                                <span
                                  class="font-weight-medium blue--text text--darken-3"
                                  >5 years:
                                </span>
                              </p>
                            </v-layout>
                            <v-layout
                              column
                              v-for="course in school.specific_classes_completed_within_5years"
                              :key="course.id"
                              class="mt-3"
                            >
                              <v-layout row align-center pl-3
                                ><span class=" blue--text text--darken-3 ">{{
                                  course.course_name
                                }}</span>
                                <span
                                  v-if="
                                    course.lab !== null &&
                                      course.lab !== undefined
                                  "
                                  class="caption grey--text ml-1"
                                  >{{ course.lab[0] }}</span
                                >
                              </v-layout>
                              <v-layout>
                                <span
                                  v-if="
                                    course.credits !== '' &&
                                      course.credits !== undefined
                                  "
                                  class="grey--text"
                                  >{{ course.credits }} credits</span
                                >
                                <span
                                  v-if="
                                    course.semester !== '' &&
                                      course.semester !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.semester }} semester hrs</span
                                >
                                <span
                                  v-if="
                                    course.quarter !== '' &&
                                      course.quarter !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.quarter }} quarter hrs</span
                                >
                              </v-layout>
                              <v-divider class="mt-2"></v-divider>
                            </v-layout>
                          </v-layout>

                          <!--
                            Specific courses that need to be completed within 7 years
                          -->
                          <v-layout
                            v-if="
                              school
                                .specific_classes_completed_within_7years[0] !==
                                0
                            "
                            column
                            class="pb-2 mt-1 "
                          >
                            <v-layout>
                              <p
                                class="font-weight-light black--text mt-1 mb-0 "
                              >
                                Following prerequisites must be completed within
                                <span
                                  class="font-weight-medium blue--text text--darken-3"
                                  >7 years:
                                </span>
                              </p>
                            </v-layout>
                            <v-layout
                              column
                              v-for="course in school.specific_classes_completed_within_7years"
                              :key="course.id"
                              class="mt-3"
                            >
                              <v-layout row align-center pl-3
                                ><span class=" blue--text text--darken-3 ">{{
                                  course.course_name
                                }}</span>
                                <span
                                  v-if="
                                    course.lab !== null &&
                                      course.lab !== undefined
                                  "
                                  class="caption grey--text ml-1"
                                  >{{ course.lab[0] }}</span
                                >
                              </v-layout>
                              <v-layout>
                                <span
                                  v-if="
                                    course.credits !== '' &&
                                      course.credits !== undefined
                                  "
                                  class="grey--text"
                                  >{{ course.credits }} credits</span
                                >
                                <span
                                  v-if="
                                    course.semester !== '' &&
                                      course.semester !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.semester }} semester hrs</span
                                >
                                <span
                                  v-if="
                                    course.quarter !== '' &&
                                      course.quarter !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.quarter }} quarter hrs</span
                                >
                              </v-layout>
                              <v-divider class="mt-2"></v-divider>
                            </v-layout>
                          </v-layout>

                          <!--
                            Specific courses that need to be completed within 8 years
                          -->
                          <v-layout
                            v-if="
                              school
                                .specific_classes_completed_within_8years[0] !==
                                0
                            "
                            column
                            class="pb-2 mt-1 "
                          >
                            <v-layout>
                              <p
                                class="font-weight-light black--text mt-1 mb-0 "
                              >
                                Following prerequisites must be completed within
                                <span
                                  class="font-weight-medium blue--text text--darken-3"
                                  >8 years:
                                </span>
                              </p>
                            </v-layout>
                            <v-layout
                              column
                              v-for="course in school.specific_classes_completed_within_8years"
                              :key="course.id"
                              class="mt-3"
                            >
                              <v-layout row align-center pl-3
                                ><span class=" blue--text text--darken-3 ">{{
                                  course.course_name
                                }}</span>
                                <span
                                  v-if="
                                    course.lab !== null &&
                                      course.lab !== undefined
                                  "
                                  class="caption grey--text ml-1"
                                  >{{ course.lab[0] }}</span
                                >
                              </v-layout>
                              <v-layout>
                                <span
                                  v-if="
                                    course.credits !== '' &&
                                      course.credits !== undefined
                                  "
                                  class="grey--text"
                                  >{{ course.credits }} credits</span
                                >
                                <span
                                  v-if="
                                    course.semester !== '' &&
                                      course.semester !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.semester }} semester hrs</span
                                >
                                <span
                                  v-if="
                                    course.quarter !== '' &&
                                      course.quarter !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.quarter }} quarter hrs</span
                                >
                              </v-layout>
                              <v-divider class="mt-2"></v-divider>
                            </v-layout>
                          </v-layout>

                          <!--
                            Specific courses that need to be completed within 10 years
                          -->
                          <v-layout
                            v-if="
                              school
                                .specific_classes_completed_within_10years[0] !==
                                0
                            "
                            column
                            class="pb-2 mt-1 "
                          >
                            <v-layout>
                              <p
                                class="font-weight-light black--text mt-1 mb-0 "
                              >
                                Following prerequisites must be completed within
                                <span
                                  class="font-weight-medium blue--text text--darken-3"
                                  >10 years:
                                </span>
                              </p>
                            </v-layout>
                            <v-layout
                              column
                              v-for="course in school.specific_classes_completed_within_10years"
                              :key="course.id"
                              class="mt-3"
                            >
                              <v-layout row align-center pl-3
                                ><span class=" blue--text text--darken-3 ">{{
                                  course.course_name
                                }}</span>
                                <span
                                  v-if="
                                    course.lab !== null &&
                                      course.lab !== undefined
                                  "
                                  class="caption grey--text ml-1"
                                  >{{ course.lab[0] }}</span
                                >
                              </v-layout>
                              <v-layout>
                                <span
                                  v-if="
                                    course.credits !== '' &&
                                      course.credits !== undefined
                                  "
                                  class="grey--text"
                                  >{{ course.credits }} credits</span
                                >
                                <span
                                  v-if="
                                    course.semester !== '' &&
                                      course.semester !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.semester }} semester hrs</span
                                >
                                <span
                                  v-if="
                                    course.quarter !== '' &&
                                      course.quarter !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.quarter }} quarter hrs</span
                                >
                              </v-layout>
                              <v-divider class="mt-2"></v-divider>
                            </v-layout>
                          </v-layout>

                          <!--
                            No courses older than 5 years accepted, unless employed full time in healthcare since completion of courses
                          -->
                          <v-layout
                            v-if="
                              school.no_courses_5years_unless_healthcare_experience &&
                                school.no_courses_5years_unless_healthcare_experience !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text">
                              No courses older than
                              <span
                                class="font-weight-medium blue--text text--darken-3"
                                >5 years</span
                              >
                              accepted, unless
                              <span
                                class="font-weight-bold grey--text text--darken-2"
                                >employed full time in healthcare
                              </span>
                              since completion of courses
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.no_courses_5years_unless_healthcare_experience &&
                                school.no_courses_5years_unless_healthcare_experience !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            Preference given if prerequisites completed within x YEARS
                          -->
                          <v-layout
                            v-if="
                              school.preference_completed_courses_within_5years !==
                                '' &&
                                school.preference_completed_courses_within_5years !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text">
                              Preference given if courses completed within<span
                                class="font-weight-medium blue--text text--darken-3"
                              >
                                {{
                                  school.preference_completed_courses_within_5years
                                }}
                                year(s)
                              </span>
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.preference_completed_courses_within_5years !==
                                '' &&
                                school.preference_completed_courses_within_5years !==
                                  undefined
                            "
                            class="mt-2 mb-2"
                          ></v-divider>
                        </v-card-text>
                      </v-card>

                      <!--
                        ALL PREREQUISTES MUST BE COMPLETED BEFORE APPLYING
                      -->
                      <v-card
                        v-if="school.prerequistes_completed_before_applying"
                        class=" mt-4  mb-3 elevation-0"
                        style="borderRadius:5px"
                        id="borderCard"
                      >
                        <v-layout
                          class=" px-2 red pb-2 pt-2 red justify-center"
                        >
                          <span
                            block
                            flat
                            class=" text-center white--text font-weight-medium"
                          >
                            All Prerequisites must be completed before
                            applying</span
                          >
                        </v-layout>
                      </v-card>

                      <!-- PREREQUISTE COMPLETION CONDITIONS -->
                      <v-card
                        v-if="
                          school.Prerequisites_completed_before_applying ||
                            (school.minimum_completed_prereqs_before_applying !==
                              '' &&
                              school.minimum_completed_prereqs_before_applying !==
                                undefined) ||
                            school
                              .specific_courses_completed_before_application[0] !==
                              0 ||
                            (school.minimum_science_credits_completed !== '' &&
                              school.minimum_science_credits_completed !==
                                undefined) ||
                            (school.number_credits_completed_before_applying !==
                              '' &&
                              school.number_credits_completed_before_applying !==
                                undefined)
                        "
                        class=" mt-4  mb-3 elevation-0"
                        style="borderRadius:5px"
                        id="borderCard"
                      >
                        <v-layout class="  pb-2 pt-2 red justify-center">
                          <span class=" white--text font-weight-medium">
                            Prerequisite Completion Conditions
                          </span>
                        </v-layout>
                        <v-card-text class="pt-2">
                          <!--
                            All prerequisites must be completed before applying
                          -->
                          <v-layout
                            v-if="
                              school.Prerequisites_completed_before_applying
                            "
                          >
                            <span class="font-weight-light black--text"
                              >All prerequisites must be completed before
                              applying</span
                            >
                          </v-layout>
                          <v-divider
                            v-if="
                              school.Prerequisites_completed_before_applying &&
                                school.Prerequisites_completed_before_applying !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            Atleast x number of prerequisites must be completed before applying
                          -->
                          <v-layout
                            v-if="
                              school.minimum_completed_prereqs_before_applying !==
                                '' &&
                                school.minimum_completed_prereqs_before_applying !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text "
                              >At least
                              <span
                                class="font-weight-medium blue--text text--darken-3"
                                >{{
                                  school.minimum_completed_prereqs_before_applying
                                }}
                                prerequisites</span
                              >
                              must be completed before applying</span
                            >
                          </v-layout>
                          <v-divider
                            v-if="
                              school.minimum_completed_prereqs_before_applying &&
                                school.minimum_completed_prereqs_before_applying !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            Minimum number of SCIENCE credits that need to be completed before applying
                          -->
                          <v-layout
                            v-if="
                              school.minimum_science_credits_completed !== '' &&
                                school.minimum_science_credits_completed !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text">
                              <span
                                class="blue--text text--darken-3 font-weight-medium"
                                >{{
                                  school.minimum_science_credits_completed
                                }}
                                Science</span
                              >
                              credits must be completed before applying
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.minimum_science_credits_completed &&
                                school.minimum_science_credits_completed !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            Total number of credits that need to be completed before applying
                          -->
                          <v-layout
                            v-if="
                              school.number_credits_completed_before_applying !==
                                '' &&
                                school.number_credits_completed_before_applying !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text">
                              <span
                                class="blue--text text--darken-3 font-weight-medium"
                                >{{
                                  school.number_credits_completed_before_applying
                                }}
                                credits</span
                              >
                              must be completed before applying
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.number_credits_completed_before_applying &&
                                school.number_credits_completed_before_applying !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            The following prerequisites must be completed before applying
                          -->
                          <v-layout
                            v-if="
                              school
                                .specific_courses_completed_before_application[0] !==
                                0
                            "
                            column
                            class="pb-2 mt-1 "
                          >
                            <v-layout>
                              <p
                                class="font-weight-light black--text mt-1 mb-0 "
                              >
                                Following prerequisites must be completed before
                                applying:
                              </p>
                            </v-layout>
                            <v-layout
                              column
                              v-for="course in school.specific_courses_completed_before_application"
                              :key="course.id"
                              class="mt-3"
                            >
                              <v-layout row align-center pl-3
                                ><span class=" blue--text text--darken-3 ">{{
                                  course.course_name
                                }}</span>
                                <span
                                  v-if="
                                    course.lab !== null &&
                                      course.lab !== undefined
                                  "
                                  class="caption grey--text ml-1"
                                  >{{ course.lab[0] }}</span
                                >
                              </v-layout>
                              <v-layout>
                                <span
                                  v-if="
                                    course.credits !== '' &&
                                      course.credits !== undefined
                                  "
                                  class="grey--text"
                                  >{{ course.credits }} credits</span
                                >
                                <span
                                  v-if="
                                    course.semester !== '' &&
                                      course.semester !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.semester }} semester hrs</span
                                >
                                <span
                                  v-if="
                                    course.quarter !== '' &&
                                      course.quarter !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.quarter }} quarter hrs</span
                                >
                              </v-layout>
                              <v-divider class="mt-2"></v-divider>
                            </v-layout>
                          </v-layout>
                        </v-card-text>
                      </v-card>

                      <!-- PENDING PREREQUISTE CONDITIONS -->
                      <v-card
                        v-if="
                          school.courses_in_progress_during_application ||
                            school
                              .specific_courses_in_progress_while_applying[0] !==
                              0 ||
                            (school.maximum_outstanding_courses_while_applying !==
                              '' &&
                              school.maximum_outstanding_courses_while_applying !==
                                undefined) ||
                            (school.first_time_applicant_minimum_number_courses_pending_before_applying !==
                              '' &&
                              school.first_time_applicant_minimum_number_courses_pending_before_applying !==
                                undefined) ||
                            (school.minimum_grade_pending_course !== '' &&
                              school.minimum_grade_pending_course !==
                                undefined) ||
                            (school.maximum_outstanding_sciences_courses_while_applying !==
                              '' &&
                              school.maximum_outstanding_sciences_courses_while_applying !==
                                undefined) ||
                            (school.maximum_outstanding_nonsciences_courses_while_applying !==
                              '' &&
                              school.maximum_outstanding_nonsciences_courses_while_applying !==
                                undefined) ||
                            (school.maximum_credits_pending_while_applying !==
                              '' &&
                              school.maximum_credits_pending_while_applying !==
                                undefined) ||
                            (school.outstanding_courses_completed_date !== '' &&
                              school.outstanding_courses_completed_date !==
                                undefined) ||
                            (school.outstanding_courses_completed_by_semester !==
                              '' &&
                              school.outstanding_courses_completed_by_semester !==
                                undefined) ||
                            (school.outstanding_sciences_courses_completed_by_semester !==
                              '' &&
                              school.outstanding_sciences_courses_completed_by_semester !==
                                undefined)
                        "
                        class=" mt-4  mb-3 elevation-0"
                        style="borderRadius:5px"
                        id="borderCard"
                      >
                        <v-layout class="  pb-2 pt-2 red justify-center">
                          <span
                            block
                            flat
                            class=" white--text font-weight-medium"
                          >
                            Pending Prerequisite Conditions
                          </span>
                        </v-layout>
                        <v-card-text class="pt-1">
                          <!--
                            Prerequisites can be in progress at time of application
                          -->
                          <v-layout
                            v-if="
                              school.courses_in_progress_during_application &&
                                (school
                                  .specific_courses_in_progress_while_applying[0] ===
                                  0 ||
                                  school.specific_courses_in_progress_while_applying ===
                                    undefined) &&
                                (school.maximum_outstanding_courses_while_applying ===
                                  '' ||
                                  school.maximum_outstanding_courses_while_applying ===
                                    undefined) &&
                                (school.first_time_applicant_minimum_number_courses_pending_before_applying ===
                                  '' ||
                                  school.first_time_applicant_minimum_number_courses_pending_before_applying ===
                                    undefined) &&
                                (school.minimum_grade_pending_course === '' ||
                                  school.minimum_grade_pending_course ===
                                    undefined) &&
                                (school.maximum_outstanding_sciences_courses_while_applying ===
                                  '' ||
                                  school.maximum_outstanding_sciences_courses_while_applying ===
                                    undefined) &&
                                (school.maximum_outstanding_nonsciences_courses_while_applying ===
                                  '' ||
                                  school.maximum_outstanding_nonsciences_courses_while_applying ===
                                    undefined) &&
                                (school.maximum_credits_pending_while_applying ===
                                  '' ||
                                  school.maximum_credits_pending_while_applying ===
                                    undefined)
                            "
                          >
                            <span class="font-weight-light black--text"
                              >Prerequisites can be in progress at time of
                              application
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.courses_in_progress_during_application &&
                                (school
                                  .specific_courses_in_progress_while_applying[0] ===
                                  0 ||
                                  school.specific_courses_in_progress_while_applying ===
                                    undefined) &&
                                (school.maximum_outstanding_courses_while_applying ===
                                  '' ||
                                  school.maximum_outstanding_courses_while_applying ===
                                    undefined) &&
                                (school.first_time_applicant_minimum_number_courses_pending_before_applying ===
                                  '' ||
                                  school.first_time_applicant_minimum_number_courses_pending_before_applying ===
                                    undefined) &&
                                (school.minimum_grade_pending_course === '' ||
                                  school.minimum_grade_pending_course ===
                                    undefined) &&
                                (school.maximum_outstanding_sciences_courses_while_applying ===
                                  '' ||
                                  school.maximum_outstanding_sciences_courses_while_applying ===
                                    undefined) &&
                                (school.maximum_outstanding_nonsciences_courses_while_applying ===
                                  '' ||
                                  school.maximum_outstanding_nonsciences_courses_while_applying ===
                                    undefined) &&
                                (school.maximum_credits_pending_while_applying ===
                                  '' ||
                                  school.maximum_credits_pending_while_applying ===
                                    undefined)
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            Only the following prerequisites can be in progress while applying
                          -->
                          <v-layout
                            v-if="
                              school
                                .specific_courses_in_progress_while_applying[0] !==
                                0
                            "
                            column
                            class="pb-2 mt-1 "
                          >
                            <v-layout>
                              <p
                                class="font-weight-light black--text mt-1 mb-0 "
                              >
                                Only the following prerequisites can be in
                                progress while applying:
                              </p>
                            </v-layout>
                            <v-layout
                              column
                              v-for="course in school.specific_courses_in_progress_while_applying"
                              :key="course.id"
                              class="mt-3"
                            >
                              <v-layout row align-center pl-3
                                ><span class=" blue--text text--darken-3 ">{{
                                  course.course_name
                                }}</span>
                                <span
                                  v-if="
                                    course.lab !== null &&
                                      course.lab !== undefined
                                  "
                                  class="caption grey--text ml-1"
                                  >{{ course.lab[0] }}</span
                                >
                              </v-layout>
                              <v-layout>
                                <span
                                  v-if="
                                    course.credits !== '' &&
                                      course.credits !== undefined
                                  "
                                  class="grey--text"
                                  >{{ course.credits }} credits</span
                                >
                                <span
                                  v-if="
                                    course.semester !== '' &&
                                      course.semester !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.semester }} semester hrs</span
                                >
                                <span
                                  v-if="
                                    course.quarter !== '' &&
                                      course.quarter !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.quarter }} quarter hrs</span
                                >
                              </v-layout>
                              <v-divider class="mt-2"></v-divider>
                            </v-layout>
                          </v-layout>

                          <!--
                            Only x number of prerequisites can be pending while applying
                          -->
                          <v-layout
                            v-if="
                              school.maximum_outstanding_courses_while_applying !==
                                '' &&
                                school.maximum_outstanding_courses_while_applying !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text"
                              >Maximum of
                              <span
                                class="blue--text text--darken-3 font-weight-medium"
                                >{{
                                  school.maximum_outstanding_courses_while_applying
                                }}
                                prerequisite(s)</span
                              >
                              can be pending while applying</span
                            >
                          </v-layout>
                          <v-divider
                            v-if="
                              school.maximum_outstanding_courses_while_applying &&
                                school.maximum_outstanding_courses_while_applying !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            First time applicant can have x number of prerequisites pending while applying
                          -->
                          <v-layout
                            v-if="
                              school.first_time_applicant_minimum_number_courses_pending_before_applying !==
                                '' &&
                                school.first_time_applicant_minimum_number_courses_pending_before_applying !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text"
                              >First time applicant can have
                              <span
                                class="blue--text text--darken-3 font-weight-medium"
                              >
                                {{
                                  school.first_time_applicant_minimum_number_courses_pending_before_applying
                                }}
                                prerequisite(s)</span
                              >
                              pending while applying</span
                            >
                          </v-layout>
                          <v-divider
                            v-if="
                              school.first_time_applicant_minimum_number_courses_pending_before_applying &&
                                school.first_time_applicant_minimum_number_courses_pending_before_applying !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            Minimum grade required for pending prerequisites
                          -->
                          <v-layout
                            v-if="
                              school.minimum_grade_pending_course !== '' &&
                                school.minimum_grade_pending_course !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text"
                              >Minimum grade of
                              <span
                                class="blue--text text--darken-3 font-weight-medium"
                                >{{ school.minimum_grade_pending_course }}
                              </span>
                              required for pending prerequisites</span
                            >
                          </v-layout>
                          <v-divider
                            v-if="
                              school.minimum_grade_pending_course &&
                                school.minimum_grade_pending_course !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            Only x number of SCIENCE prerequisites can be pending while applying
                          -->
                          <v-layout
                            v-if="
                              school.maximum_outstanding_sciences_courses_while_applying !==
                                '' &&
                                school.maximum_outstanding_sciences_courses_while_applying !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text"
                              >Maximum of
                              <span
                                class="blue--text text--darken-3 font-weight-medium"
                                >{{
                                  school.maximum_outstanding_sciences_courses_while_applying
                                }}
                                SCIENCE prerequisites</span
                              >
                              can be pending while applying</span
                            >
                          </v-layout>
                          <v-divider
                            v-if="
                              school.maximum_outstanding_sciences_courses_while_applying &&
                                school.maximum_outstanding_sciences_courses_while_applying !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            Only x number of NON-SCIENCE prerequisites can be pending while applying
                          -->
                          <v-layout
                            v-if="
                              school.maximum_outstanding_nonsciences_courses_while_applying !==
                                '' &&
                                school.maximum_outstanding_nonsciences_courses_while_applying !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text"
                              >Maximum of
                              <span
                                class="blue--text text--darken-3 font-weight-medium"
                                >{{
                                  school.maximum_outstanding_nonsciences_courses_while_applying
                                }}
                                NON-SCIENCE prerequisites</span
                              >
                              can be pending while applying</span
                            >
                          </v-layout>
                          <v-divider
                            v-if="
                              school.maximum_outstanding_nonsciences_courses_while_applying &&
                                school.maximum_outstanding_nonsciences_courses_while_applying !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!-- Only x credits can be pending while applying -->
                          <v-layout
                            v-if="
                              school.maximum_credits_pending_while_applying !==
                                '' &&
                                school.maximum_credits_pending_while_applying !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text"
                              >Maximum of<span
                                class="blue--text text--darken-3 font-weight-medium ml-1"
                                >{{
                                  school.maximum_credits_pending_while_applying
                                }}
                                credits</span
                              >
                              can be pending while applying</span
                            >
                          </v-layout>
                          <v-divider
                            v-if="
                              school.maximum_credits_pending_while_applying &&
                                school.maximum_credits_pending_while_applying !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            Pending prerequisites must be completed by date
                          -->
                          <v-layout
                            v-if="
                              school.outstanding_courses_completed_date !==
                                '' &&
                                school.outstanding_courses_completed_date !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text"
                              >Pending prerequisites must be completed by
                              <span
                                class="blue--text text--darken-3 font-weight-medium"
                                >{{
                                  school.outstanding_courses_completed_date
                                    | removeTimeFromDate
                                    | moment("MMMM Do")
                                }}
                              </span>
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.outstanding_courses_completed_date &&
                                school.outstanding_courses_completed_date !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            Pending prerequisites must be completed by Semester
                          -->
                          <v-layout
                            v-if="
                              school.outstanding_courses_completed_by_semester !==
                                '' &&
                                school.outstanding_courses_completed_by_semester !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text"
                              >Pending prerequisites must be completed by end of
                              <span
                                class="blue--text text--darken-3 font-weight-medium"
                                >{{
                                  school.outstanding_courses_completed_by_semester
                                }}
                                semester
                              </span>
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.outstanding_courses_completed_by_semester &&
                                school.outstanding_courses_completed_by_semester !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!--
                            Pending SCIENCE prerequisites must be completed by date
                          -->
                          <v-layout
                            v-if="
                              school.outstanding_sciences_courses_completed_by_semester !==
                                '' &&
                                school.outstanding_sciences_courses_completed_by_semester !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text"
                              >Pending
                              <span
                                class="font-weight-bold grey--text text--darken-2  "
                                >SCIENCE </span
                              >prerequisites must be completed by end of
                              <span
                                class="blue--text text--darken-3 font-weight-medium"
                                >{{
                                  school.outstanding_sciences_courses_completed_by_semester
                                }}
                                semester
                              </span>
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.outstanding_sciences_courses_completed_by_semester &&
                                school.outstanding_sciences_courses_completed_by_semester !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>
                        </v-card-text>
                      </v-card>

                      <!-- OTHER PREREQUISTE CONDITIONS -->
                      <v-card
                        v-if="
                          school.either_course_credits_completed[0] !== 0 ||
                            school
                              .specific_courses_completed_4_year_college[0] !==
                              0 ||
                            school.courses_waived_with_bachelors[0] !== 0
                        "
                        class=" mt-4  mb-3 elevation-0"
                        style="borderRadius:5px"
                        id="borderCard"
                      >
                        <v-layout class=" pb-2 pt-2 red justify-center">
                          <span class=" white--text font-weight-medium">
                            Other Prerequisite Conditions
                          </span>
                        </v-layout>
                        <v-card-text pt-2 class="pt-0">
                          <!--
                            Following prerequisites must be completed at 4 year college
                          -->
                          <v-layout
                            v-if="
                              school
                                .specific_courses_completed_4_year_college[0] !==
                                0
                            "
                            column
                            class="pb-2 mt-1 "
                          >
                            <v-layout>
                              <p
                                class="font-weight-light  black--text mt-1 mb-0 "
                              >
                                Following prerequisites must be completed at 4
                                year college:
                              </p>
                            </v-layout>
                            <v-layout
                              column
                              v-for="course in school.specific_courses_completed_4_year_college"
                              :key="course.id"
                              class="mt-3"
                            >
                              <v-layout row align-center pl-3
                                ><span class=" blue--text text--darken-3 ">{{
                                  course.course_name
                                }}</span>
                                <span
                                  v-if="
                                    course.lab !== null &&
                                      course.lab !== undefined
                                  "
                                  class="caption grey--text ml-1"
                                  >{{ course.lab[0] }}</span
                                >
                              </v-layout>
                              <v-layout>
                                <span
                                  v-if="
                                    course.credits !== '' &&
                                      course.credits !== undefined
                                  "
                                  class="grey--text"
                                  >{{ course.min_credits }} credits</span
                                >
                                <span
                                  v-if="
                                    course.semester !== '' &&
                                      course.semester !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.semester }} semester hrs</span
                                >
                                <span
                                  v-if="
                                    course.quarter !== '' &&
                                      course.quarter !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.quarter }} quarter hrs</span
                                >
                              </v-layout>
                              <v-divider class="mt-2"></v-divider>
                            </v-layout>
                          </v-layout>

                          <!--
                            Following prerequisites are waived with completion of Bachelors Degree
                          -->
                          <v-layout
                            v-if="school.courses_waived_with_bachelors[0] !== 0"
                            column
                            class="pb-2 mt-1 "
                          >
                            <v-layout>
                              <p
                                class="font-weight-light black--text mt-1 mb-0 "
                              >
                                Following prerequisites are waived with
                                completion of Bachelors Degree:
                              </p>
                            </v-layout>
                            <v-layout
                              column
                              v-for="course in school.courses_waived_with_bachelors"
                              :key="course.id"
                              class="mt-3"
                            >
                              <v-layout row align-center pl-3
                                ><span class=" blue--text text--darken-3 ">{{
                                  course.course_name
                                }}</span>
                                <span
                                  v-if="
                                    course.lab !== null &&
                                      course.lab !== undefined
                                  "
                                  class="caption grey--text ml-1"
                                  >{{ course.lab[0] }}</span
                                >
                              </v-layout>
                              <v-layout>
                                <span
                                  v-if="
                                    course.credits !== '' &&
                                      course.credits !== undefined
                                  "
                                  class="grey--text"
                                  >{{ course.min_credits }} credits</span
                                >
                                <span
                                  v-if="
                                    course.semester !== '' &&
                                      course.semester !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.semester }} semester hrs</span
                                >
                                <span
                                  v-if="
                                    course.quarter !== '' &&
                                      course.quarter !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.quarter }} quarter hrs</span
                                >
                              </v-layout>
                              <v-divider class="mt-2"></v-divider>
                            </v-layout>
                          </v-layout>
                        </v-card-text>
                      </v-card>

                      <!-- COMMUNITY COLLEGE COURSE CONDITIONS -->
                      <v-card
                        v-if="
                          (school.community_college_courses_accepted &&
                            school.community_college_courses_accepted !==
                              undefined) ||
                            (school.community_college_courses_accepted_regionally_accredited &&
                              school.community_college_courses_accepted_regionally_accredited !==
                                undefined)
                        "
                        class=" mt-4  mb-3 elevation-0"
                        style="borderRadius:5px"
                        id="borderCard"
                      >
                        <v-layout class=" px-2 justify-center pb-2 pt-2 ">
                          <span
                            class=" text-center  green--text font-weight-medium"
                          >
                            Community College courses accepted if school is
                            regionally accredited
                          </span>
                        </v-layout>
                      </v-card>

                      <!-- ONLINE/WEB BASED COURSE CONDITIONS -->
                      <v-card
                        v-if="
                          (school.online_courses_accepted &&
                            school.online_courses_accepted !== undefined) ||
                            (school.online_courses_lab_accepted &&
                              school.online_courses_lab_accepted !==
                                undefined) ||
                            (school.online_science_courses_accepted &&
                              school.online_science_courses_accepted !==
                                undefined) ||
                            (school.online_nonscience_courses_accepted &&
                              school.online_nonscience_courses_accepted !==
                                undefined) ||
                            school
                              .online_credits_accepted_specific_courses[0] !==
                              0 ||
                            (school.online_courses_accepted_regionally_accredited &&
                              school.online_courses_accepted_regionally_accredited !==
                                undefined)
                        "
                        class=" mt-4  mb-3 elevation-0"
                        style="borderRadius:5px"
                        id="borderCard"
                      >
                        <v-layout class=" px-2 justify-center pb-2 pt-2 ">
                          <span
                            class="text-center green--text font-weight-medium"
                          >
                            Online courses accepted if school is regionally
                            accredited</span
                          >
                        </v-layout>
                        <v-card-text
                          v-if="
                            school
                              .online_credits_accepted_specific_courses[0] !==
                              0 ||
                              (school.online_nonscience_courses_accepted &&
                                school.online_nonscience_courses_accepted !==
                                  undefined) ||
                              (school.online_courses_lab_accepted &&
                                school.online_courses_lab_accepted !==
                                  undefined)
                          "
                          class="pt-1 pb-1"
                        >
                          <!-- Online credits accepted for specific courses -->
                          <v-layout
                            v-if="
                              school
                                .online_credits_accepted_specific_courses[0] !==
                                0
                            "
                            column
                            class="pb-2 mt-1 "
                          >
                            <v-layout>
                              <p
                                class="font-weight-light black--text mt-1 mb-0 "
                              >
                                For Following Prerequisites:
                              </p>
                            </v-layout>
                            <v-layout
                              column
                              v-for="course in school.online_credits_accepted_specific_courses"
                              :key="course.id"
                              class="mt-3"
                            >
                              <v-layout row align-center pl-3
                                ><span class=" blue--text text--darken-3 ">{{
                                  course.course_name
                                }}</span>
                                <span
                                  v-if="
                                    course.lab !== null &&
                                      course.lab !== undefined
                                  "
                                  class="caption grey--text ml-1"
                                  >{{ course.lab[0] }}</span
                                >
                              </v-layout>
                              <v-layout>
                                <span
                                  v-if="
                                    course.credits !== '' &&
                                      course.credits !== undefined
                                  "
                                  class="grey--text"
                                  >{{ course.credits }} credits</span
                                >
                                <span
                                  v-if="
                                    course.semester !== '' &&
                                      course.semester !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.semester }} semester hrs</span
                                >
                                <span
                                  v-if="
                                    course.quarter !== '' &&
                                      course.quarter !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.quarter }} quarter hrs</span
                                >
                              </v-layout>
                              <v-divider class="mt-2"></v-divider>
                            </v-layout>
                          </v-layout>

                          <!-- Online NON-SCIENCE courses accepted -->
                          <v-layout
                            v-if="
                              school.online_nonscience_courses_accepted &&
                                school.online_nonscience_courses_accepted !==
                                  undefined
                            "
                          >
                            <span class="font-weight-light black--text">
                              Only
                              <span
                                class="font-weight-bold grey--text text--darken-2"
                                >NON-SCIENCE</span
                              >
                              courses accepted
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.online_nonscience_courses_accepted &&
                                school.online_nonscience_courses_accepted !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>

                          <!-- Online courses lab component accepted -->
                          <v-layout
                            v-if="
                              school.online_courses_lab_accepted &&
                                school.online_courses_lab_accepted !== undefined
                            "
                            mt-1
                          >
                            <span class="font-weight-light black--text">
                              <span
                                class="font-weight-bold grey--text text--darken-2"
                                >Online lab
                              </span>
                              component accepted for courses
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.online_courses_lab_accepted &&
                                school.online_courses_lab_accepted !== undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>
                        </v-card-text>
                      </v-card>

                      <!-- ADVANCED PLACEMENT PREREQUISTE CONDITIONS -->
                      <v-card
                        v-if="
                          (school.ap_credits_accepted &&
                            school.ap_credits_accepted !== undefined) ||
                            (school.ap_science_credits_accepted &&
                              school.ap_science_credits_accepted !==
                                undefined) ||
                            (school.ap_nonscience_credits_accepted &&
                              school.ap_nonscience_credits_accepted !==
                                undefined) ||
                            school.ap_credits_accepted_specific_courses[0] !==
                              0 ||
                            (school.ap_credits_accepted_transcript &&
                              school.ap_credits_accepted_transcript !==
                                undefined)
                        "
                        class=" mt-4  mb-3 elevation-0"
                        style="borderRadius:5px"
                        id="borderCard"
                      >
                        <v-layout class=" px-2 justify-center pb-2 pt-2 ">
                          <span
                            class="text-center green--text font-weight-medium"
                          >
                            AP credits accepted if they appear on official
                            transcript</span
                          >
                        </v-layout>
                        <v-card-text
                          v-if="
                            (school.ap_nonscience_credits_accepted &&
                              school.ap_nonscience_credits_accepted !==
                                undefined) ||
                              school.ap_credits_accepted_specific_courses[0] !==
                                0
                          "
                          class="pt-0 pb-1"
                        >
                          <!-- AP credits accepted for specific courses -->
                          <v-layout
                            v-if="
                              school.ap_credits_accepted_specific_courses[0] !==
                                0
                            "
                            column
                            class="pb-2 mt-1 "
                          >
                            <v-layout>
                              <p
                                class="font-weight-light black--text mt-1 mb-0 "
                              >
                                For Following Prerequisites:
                              </p>
                            </v-layout>
                            <v-layout
                              column
                              v-for="course in school.ap_credits_accepted_specific_courses"
                              :key="course.id"
                              class="mt-3"
                            >
                              <v-layout row align-center pl-3
                                ><span class=" blue--text text--darken-3 ">{{
                                  course.course_name
                                }}</span>
                                <span
                                  v-if="
                                    course.lab !== null &&
                                      course.lab !== undefined
                                  "
                                  class="caption grey--text ml-1"
                                  >{{ course.lab[0] }}</span
                                >
                              </v-layout>
                              <v-layout>
                                <span
                                  v-if="
                                    course.credits !== '' &&
                                      course.credits !== undefined
                                  "
                                  class="grey--text"
                                  >{{ course.credits }} credits</span
                                >
                                <span
                                  v-if="
                                    course.semester !== '' &&
                                      course.semester !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.semester }} semester hrs</span
                                >
                                <span
                                  v-if="
                                    course.quarter !== '' &&
                                      course.quarter !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.quarter }} quarter hrs</span
                                >
                              </v-layout>
                              <v-divider class="mt-2"></v-divider>
                            </v-layout>
                          </v-layout>
                          <!-- AP NON-SCIENCE credits/courses accepted -->
                          <v-layout
                            v-if="
                              school.ap_nonscience_credits_accepted &&
                                school.ap_nonscience_credits_accepted !==
                                  undefined
                            "
                            mt-2
                          >
                            <span class="font-weight-light black--text">
                              Only
                              <span
                                class="font-weight-bold grey--text text--darken-2"
                                >NON-SCIENCE</span
                              >
                              credits accepted
                            </span>
                          </v-layout>
                          <v-divider
                            v-if="
                              school.ap_nonscience_credits_accepted &&
                                school.ap_nonscience_credits_accepted !==
                                  undefined
                            "
                            class="mt-2 mb-2 "
                          ></v-divider>
                        </v-card-text>
                      </v-card>

                      <!-- PASS/FAIL CONDITIONS -->
                      <v-card
                        v-if="school.pass_fail_grade_accepted"
                        class=" mt-4  mb-3 elevation-0"
                        style="borderRadius:5px"
                        id="borderCard"
                      >
                        <v-layout class=" px-2 justify-center  pb-2 pt-2 ">
                          <span class="green--text font-weight-medium">
                            Pass/Fail Grade Accepted</span
                          >
                        </v-layout>
                        <v-card-text
                          v-if="
                            school.pass_fail_grade_accepted_courses !== null &&
                              school.pass_fail_grade_accepted_courses !==
                                undefined &&
                              school.pass_fail_grade_accepted_courses[0] !== 0
                          "
                          class="pt-2 pb-1"
                        >
                          <v-layout column class="pb-2 mt-1">
                            <v-layout class="pb-2 ">
                              <span class="font-weight-light black--text mb-0"
                                >For Following Prerequisites:</span
                              ></v-layout
                            >
                            <v-layout
                              column
                              v-for="course in school.pass_fail_grade_accepted_courses"
                              :key="course.id"
                              class="mt-1 ml-2"
                            >
                              <v-layout row align-center>
                                <span class=" blue--text text--darken-3 pl-3">{{
                                  course.course_name
                                }}</span>
                              </v-layout>

                              <v-divider class="mt-2"></v-divider>
                            </v-layout>
                          </v-layout>
                        </v-card-text>
                      </v-card>

                      <!-- CLEP(College Level Examination Program) -->
                      <v-card
                        v-if="
                          (school.clep_accepted &&
                            school.clep_accepted !== undefined) ||
                            school.clep_accepted_specific_courses[0] !== 0
                        "
                        class=" mt-4  mb-3 elevation-0"
                        style="borderRadius:5px"
                        id="borderCard"
                      >
                        <v-layout class=" px-2 justify-center  pb-2 pt-2 ">
                          <span
                            class=" text-center green--text font-weight-medium"
                          >
                            CLEP credits accepted</span
                          >
                        </v-layout>
                        <v-card-text
                          v-if="school.clep_accepted_specific_courses[0] !== 0"
                          class="pt-2"
                        >
                          <!-- CLEP for specific courses -->
                          <v-layout
                            v-if="
                              school.clep_accepted_specific_courses[0] !== 0
                            "
                            column
                            class="pb-2 mt-1 "
                          >
                            <v-layout>
                              <p
                                class="font-weight-light black--text mt-1 mb-0 "
                              >
                                For Following Prerequisites:
                              </p>
                            </v-layout>
                            <v-layout
                              column
                              v-for="course in school.clep_accepted_specific_courses"
                              :key="course.id"
                              class="mt-3"
                            >
                              <v-layout row align-center pl-3
                                ><span class=" blue--text text--darken-3 ">{{
                                  course.course_name
                                }}</span>
                                <span
                                  v-if="
                                    course.lab !== null &&
                                      course.lab !== undefined
                                  "
                                  class="caption grey--text ml-1"
                                  >{{ course.lab[0] }}</span
                                >
                              </v-layout>
                              <v-layout>
                                <span
                                  v-if="
                                    course.credits !== '' &&
                                      course.credits !== undefined
                                  "
                                  class="grey--text"
                                  >{{ course.credits }} credits</span
                                >
                                <span
                                  v-if="
                                    course.semester !== '' &&
                                      course.semester !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.semester }} semester hrs</span
                                >
                                <span
                                  v-if="
                                    course.quarter !== '' &&
                                      course.quarter !== undefined
                                  "
                                  class="grey--text"
                                >
                                  - {{ course.quarter }} quarter hrs</span
                                >
                              </v-layout>
                              <v-divider class="mt-2"></v-divider>
                            </v-layout>
                          </v-layout>
                        </v-card-text>
                      </v-card>

                      <!-- Community College Courses NOT accepted -->
                      <v-card
                        v-if="
                          !school.community_college_courses_accepted ||
                            (school.community_college_courses_accepted ===
                              undefined &&
                              !school.community_college_courses_accepted_regionally_accredited) ||
                            school.community_college_courses_accepted_regionally_accredited ===
                              undefined
                        "
                        class=" mt-4  mb-3 "
                        flat
                        outlined
                      >
                        <v-layout
                          class=" px-2   pb-2 pt-2  align-center justify-center"
                        >
                          <span
                            class=" text-center  red--text font-weight-medium"
                          >
                            Community College courses NOT accepted
                          </span>
                        </v-layout>
                      </v-card>

                      <!-- Online Courses NOT accepted -->
                      <v-card
                        v-if="
                          !school.online_courses_accepted ||
                            (school.online_courses_accepted === undefined &&
                              !school.online_courses_lab_accepted) ||
                            (school.online_courses_lab_accepted === undefined &&
                              !school.online_science_courses_accepted) ||
                            (school.online_science_courses_accepted ===
                              undefined &&
                              !school.online_nonscience_courses_accepted) ||
                            (school.online_nonscience_courses_accepted ===
                              undefined &&
                              school
                                .online_credits_accepted_specific_courses[0] ===
                                0 &&
                              !school.online_courses_accepted_regionally_accredited) ||
                            school.online_courses_accepted_regionally_accredited ===
                              undefined
                        "
                        class="mt-4"
                        flat
                        outlined
                      >
                        <v-layout class=" px-2 justify-center pb-2 pt-2 ">
                          <span class="red--text font-weight-medium">
                            Online courses NOT accepted
                          </span>
                        </v-layout>
                      </v-card>

                      <!-- AP credits NOT accepted -->
                      <v-card
                        v-if="
                          !school.ap_credits_accepted ||
                            (school.ap_credits_accepted === undefined &&
                              !school.ap_science_credits_accepted) ||
                            (school.ap_science_credits_accepted === undefined &&
                              !school.ap_nonscience_credits_accepted) ||
                            (school.ap_nonscience_credits_accepted ===
                              undefined &&
                              school.ap_credits_accepted_specific_courses[0] ===
                                0 &&
                              !school.ap_credits_accepted_transcript) ||
                            school.ap_credits_accepted_transcript === undefined
                        "
                        class="mt-4"
                        flat
                        outlined
                      >
                        <v-layout class=" px-2 justify-center pb-2 pt-2 ">
                          <span class="red--text font-weight-medium">
                            AP credits NOT accepted</span
                          >
                        </v-layout>
                      </v-card>

                      <!-- Pass/Fail Grade NOT accepted -->
                      <v-card
                        v-if="
                          !school.pass_fail_grade_accepted ||
                            school.pass_fail_grade_accepted === undefined
                        "
                        class="mt-4 "
                        flat
                        outlined
                      >
                        <v-layout class=" px-2 justify-center  pb-2 pt-2 ">
                          <span class="red--text font-weight-medium">
                            Pass/Fail Grade NOT accepted</span
                          >
                        </v-layout>
                      </v-card>

                      <!-- CLEP credits NOT accepted -->
                      <v-card
                        v-if="
                          !school.clep_accepted ||
                            (school.clep_accepted === undefined &&
                              school.clep_accepted_specific_courses[0] === 0)
                        "
                        class="mt-4"
                        flat
                        outlined
                      >
                        <v-layout class=" px-2 justify-center  pb-2 pt-2 ">
                          <span
                            class=" text-center red--text font-weight-medium"
                          >
                            CLEP credits NOT accepted</span
                          >
                        </v-layout>
                      </v-card>
                    </v-card-text>
                  </v-card>

                  <!-- Prerequisite Notes -->
                  <v-card
                    v-if="school.prerequistesNotes"
                    outlined
                    class=" mt-4 mb-4"
                  >
                    <v-layout align-center justify-center class=" pb-1">
                      <v-icon small class="mr-2"
                        >mdi-message-text-outline</v-icon
                      >
                      <span class="font-weight-light align-center">
                        Additional Notes
                      </span>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-text class="text-center">
                      <span>{{ school.prerequistesNotes }}</span>
                    </v-card-text>
                  </v-card>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Experience Hours -->
          <v-expansion-panels focusable class="px-2">
            <v-expansion-panel class="mt-4">
              <v-expansion-panel-header class="light-blue--text text--darken-4">
                <v-layout row align-center>
                  <v-icon color="blue darken-3">mdi-hospital-box</v-icon>
                  <span
                    class="ml-2 blue--text text--darken-3 font-weight-medium"
                    >Experience Hours</span
                  >
                </v-layout>
              </v-expansion-panel-header>
              <v-expansion-panel-content class=" px-0 mx-0 pb-0 elevation-0">
                <!-- Healthcare Information -->
                <v-layout column>
                  <!-- Healthcare Hours Card -->
                  <v-card class="elevation-0 innerCardCover" outlined>
                    <v-layout
                      v-if="school.healthcare_experience_required"
                      class="red pb-2 justify-center"
                    >
                      <span
                        v-if="school.healthcare_experience_required"
                        class="white--text text-center mt-2"
                        >Experience Hours Required</span
                      >
                    </v-layout>
                    <v-layout
                      v-if="school.healthcare_experience_recommended"
                      class="amber darken-3 pb-2 justify-center"
                    >
                      <span class="white--text text-center mt-2"
                        >Experience Hours Recommended</span
                      >
                    </v-layout>

                    <v-layout
                      v-if="
                        school.healthcare_experience_required === false &&
                          school.healthcare_experience_recommended === false
                      "
                      class="grey pb-2 justify-center"
                    >
                      <span class="white--text text-center mt-2"
                        >Experience Hours Not Required</span
                      >
                    </v-layout>

                    <v-layout
                      v-if="school.healthcare_experience_required"
                      mt-4
                      mb-2
                      column
                      align-center
                      justify-center
                    >
                      <v-progress-circular
                        v-if="school.healthcare_experience_minimum_hours !== ''"
                        :width="3"
                        size="80"
                        :value="100"
                        color="grey"
                      >
                        <span
                          class="percentageValue headline font-weight-medium red--text"
                          >{{
                            school.healthcare_experience_minimum_hours
                          }}</span
                        ></v-progress-circular
                      >
                      <span
                        v-if="school.healthcare_experience_minimum_hours === ''"
                        class="  mb-0  body-1 font-weight-light"
                        >No Specified Hours</span
                      >
                      <span
                        v-if="school.healthcare_experience_minimum_hours !== ''"
                        class="mt-1   font-weight-light"
                        >Hours</span
                      >
                    </v-layout>

                    <v-layout
                      v-if="school.healthcare_experience_recommended"
                      mt-4
                      mb-2
                      column
                      align-center
                      justify-center
                    >
                      <v-progress-circular
                        v-if="school.healthcare_experience_minimum_hours !== ''"
                        :width="3"
                        size="80"
                        :value="100"
                        color="grey"
                      >
                        <span
                          class="percentageValue headline font-weight-medium amber--text text--darken-3"
                          >{{
                            school.healthcare_experience_minimum_hours
                          }}</span
                        ></v-progress-circular
                      >
                      <span
                        v-if="school.healthcare_experience_minimum_hours === ''"
                        class=" mb-0  body-1 font-weight-light"
                        >No Specified Hours</span
                      >
                      <span
                        v-if="school.healthcare_experience_minimum_hours !== ''"
                        class="mt-1 font-weight-light"
                        >Hours</span
                      >
                    </v-layout>
                  </v-card>

                  <v-alert
                    type="info"
                    v-if="!checkUserLoggedIn || !checkUserIsSubscribed"
                    class="mt-5"
                  >
                    <v-row class="d-sm-flex flex-column flex-lg-row">
                      <v-col
                        v-if="school.healthcare_experience_required"
                        class="pt-0 grow"
                      >
                        Do you meet the minimum experience requirement for this
                        school?
                        <span v-if="!checkUserLoggedIn"> Sign up </span>
                        <span v-else-if="!checkUserIsSubscribed">
                          Subscribe</span
                        >
                        to keep track of all your experience in the "Experience"
                        section of your dashboard to see if you qualify for this
                        program.
                      </v-col>
                      <v-col
                        v-if="school.healthcare_experience_recommended"
                        class="grow"
                      >
                        Even though this program recommends experience hours, it
                        is strongly suggested for you to gain experience before
                        applying.
                        <span v-if="!checkUserLoggedIn"> Sign up </span>
                        <span v-else-if="!checkUserIsSubscribed">
                          Subscribe</span
                        >
                        to keep track of all your experience in the "Experience"
                        section of your dashboard to see if you qualify for this
                        program.
                      </v-col>
                      <v-col
                        v-if="
                          !school.healthcare_experience_required &&
                            !school.healthcare_experience_recommended
                        "
                        class="grow"
                      >
                        Even though this program does not require experience
                        hours, it is strongly suggested for you to gain
                        experience before applying.
                        <span v-if="!checkUserLoggedIn"> Sign up </span>
                        <span v-else-if="!checkUserIsSubscribed">
                          Subscribe</span
                        >
                        to keep track of all your experience in the "Experience"
                        section of your dashboard to see if you qualify for this
                        program.
                      </v-col>
                      <v-col class="shrink">
                        <v-btn v-if="!checkUserLoggedIn" to="/LoginSignupPage"
                          >Sign Up</v-btn
                        >
                        <v-btn
                          v-else-if="!checkUserIsSubscribed"
                          to="/LoginSignupPage"
                          >Subscribe</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-alert>

                  <!-- Accepted Experience Card -->
                  <v-card
                    v-if="
                      school.healthcare_experience_required ||
                        school.healthcare_experience_recommended
                    "
                    class=" elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout justify-center class=" grey lighten-3 pb-2 ">
                      <span class="subtitle-1 mt-2 font-weight-regular">
                        Accepted Experience
                      </span>
                      <v-icon
                        @click="showAcceptedExpDialog = true;"
                        small
                        class=" ml-2"
                        >mdi-information</v-icon
                      >
                    </v-layout>

                    <v-card-text class="pt-2  ">
                      <v-layout column class="pl-0 ml-0 ">
                        <v-layout
                          v-if="
                            school.healthcare_experience_direct_paid_patient_hours ===
                              false &&
                              school.healthcare_experience_direct_patient_hours ===
                                false &&
                              school.healthcare_experience_indirect_patient_hours ===
                                false &&
                              school.healthcare_experience_volunteer_hours ===
                                false
                          "
                          align-center
                          justify-space-between
                        >
                          <span class="">Any experience accepted</span>
                          <v-icon color="green" class="" size="20px"
                            >mdi-check-circle</v-icon
                          >
                        </v-layout>

                        <v-layout
                          v-if="
                            school.healthcare_experience_direct_paid_patient_hours ===
                              true
                          "
                          mt-2
                          row
                          align-center
                          justify-space-between
                          mx-0
                        >
                          <span class=" font-weight-light black--text "
                            >Paid Direct Patient Care</span
                          >
                          <v-icon color="blue darken-3" class="" size="20px"
                            >mdi-check-circle</v-icon
                          >
                        </v-layout>
                        <v-divider
                          v-if="
                            school.healthcare_experience_direct_paid_patient_hours ===
                              true
                          "
                          class="mt-2 mb-1 "
                        ></v-divider>

                        <v-layout
                          v-if="
                            school.healthcare_experience_direct_patient_hours ===
                              true
                          "
                          mt-2
                          row
                          align-center
                          justify-space-between
                          mx-0
                        >
                          <span class="font-weight-light black--text"
                            >Direct Patient Care
                          </span>
                          <v-icon color="blue darken-3" class="" size="20px"
                            >mdi-check-circle</v-icon
                          >
                        </v-layout>
                        <v-divider
                          v-if="
                            school.healthcare_experience_direct_patient_hours ===
                              true
                          "
                          class="mt-2 mb-1 "
                        ></v-divider>

                        <v-layout
                          v-if="
                            school.healthcare_experience_indirect_patient_hours ===
                              true
                          "
                          mt-2
                          row
                          align-center
                          justify-space-between
                          mx-0
                        >
                          <span class="font-weight-light black--text"
                            >Indirect Patient Care
                          </span>
                          <v-icon color="blue darken-3" class="" size="20px"
                            >mdi-check-circle</v-icon
                          >
                        </v-layout>
                        <v-divider
                          v-if="
                            school.healthcare_experience_indirect_patient_hours ===
                              true
                          "
                          class="mt-2 mb-1 "
                        ></v-divider>

                        <v-layout
                          v-if="
                            school.healthcare_experience_volunteer_hours ===
                              true
                          "
                          mt-2
                          row
                          align-center
                          justify-space-between
                          mx-0
                        >
                          <span class="black--text font-weight-light"
                            >Volunteer</span
                          >
                          <v-icon color="blue darken-3" class="" size="20px"
                            >mdi-check-circle</v-icon
                          >
                        </v-layout>
                        <!--
                          MINIMUM VOLUNTEER HOURS NEED TO BE COMPLETED WITHIN
                        -->
                        <v-layout
                          v-if="
                            school.healthcare_experience_minimum_volunteer_hours !==
                              '' &&
                              school.healthcare_experience_minimum_volunteer_hours !==
                                undefined
                          "
                          row
                          mt-1
                        >
                          <span class="ml-3  grey--text ">
                            Minimum Volunteer Hours:
                            <span class="font-weight-bold red--text"
                              >{{
                                school.healthcare_experience_minimum_volunteer_hours
                              }}
                              hrs</span
                            >
                          </span>
                        </v-layout>
                        <v-divider
                          v-if="
                            school.healthcare_experience_volunteer_hours ===
                              true
                          "
                          class="mt-2 mb-1 "
                        ></v-divider>
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <!-- ACCEPTED EXPERIENCE DIALOG -->
                  <v-dialog
                    v-model="showAcceptedExpDialog"
                    scrollable
                    max-width="400"
                    persistent
                    style="zIndex:2000"
                  >
                    <v-card style="borderRadius:10px">
                      <v-card-title
                        class="title grey lighten-2 text-xs-center mb-2"
                      >
                        Healthcare Experience Hours
                      </v-card-title>
                      <v-card-text class="text-xs-justify">
                        Each program's definitions and requirements of
                        patient/healthcare experience vary. If you have any
                        questions about your experiences fulfilling an
                        individual program's patient/healthcare experience
                        requirements, contact that program directly.
                      </v-card-text>

                      <v-card-text class="pt-0">
                        <v-subheader
                          class="pl-0 black--text"
                          style="height:30px"
                          >Paid Direct Patient Care Experience:</v-subheader
                        >
                        Paid experiences in which you are directly responsible
                        for a patient's care.
                      </v-card-text>

                      <v-card-text class="pt-0">
                        <v-subheader
                          class="pl-0 black--text"
                          style="height:30px"
                          >Direct Patient Care Experience:</v-subheader
                        >
                        Non-paid (volunteer) experiences in which you are
                        directly responsible for a patient's care.
                      </v-card-text>

                      <v-card-text class="pt-0">
                        <v-subheader
                          class="pl-0 black--text"
                          style="height:30px"
                          >Indirect Patient Care Experience:</v-subheader
                        >
                        Both paid and unpaid (volunteer) experiences in a health
                        or health-related field where you are not directly
                        responsible for a patient's care, but may still have
                        patient interaction.
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          @click="showAcceptedExpDialog = false;"
                          block
                          color="red"
                          class="elevation-0"
                          dark
                          >Close</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <!-- Healthcare Conditions Card -->
                  <v-card
                    v-if="
                      school.healthcare_experience_minimum_year !== '' &&
                        school.healthcare_experience_minimum_year !== undefined
                    "
                    class="mt-4 elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout justify-center class=" grey lighten-3 pb-2 ">
                      <span class="subtitle-1 mt-2 font-weight-regular">
                        Conditions
                      </span>
                    </v-layout>

                    <v-card-text class="pt-2  ">
                      <v-layout column class="pl-0 ml-0 ">
                        <v-layout
                          mt-2
                          row
                          align-center
                          justify-space-between
                          mx-0
                        >
                          <span class=" font-weight-light black--text "
                            >Healthcare Experience needs to be completed within
                            <span
                              class="font-weight-medium blue--text text--darken-3"
                              >{{
                                school.healthcare_experience_minimum_year
                              }}
                              years</span
                            ></span
                          >
                        </v-layout>
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <!-- COMMUNITY SERVICE CARD -->
                  <v-card
                    v-if="
                      school.healthcare_experience_community_service === true
                    "
                    class="mt-4 pb-0 elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout class="red pb-2 justify-center">
                      <span class="white--text text-center mt-2"
                        >Community Service Hours Required</span
                      >
                    </v-layout>

                    <v-layout
                      v-if="
                        school.healthcare_experience_community_service_hours !==
                          '' &&
                          school.healthcare_experience_community_service_hours !==
                            undefined
                      "
                      mt-4
                      mb-2
                      column
                      align-center
                      justify-center
                    >
                      <v-progress-circular
                        :width="3"
                        size="80"
                        :value="100"
                        color="grey"
                      >
                        <span
                          class="percentageValue headline  font-weight-medium red--text"
                          >{{
                            school.healthcare_experience_community_service_hours
                          }}</span
                        ></v-progress-circular
                      >
                      <span class=" mt-1 black--text font-weight-light"
                        >Hours</span
                      >
                    </v-layout>

                    <v-layout v-else mt-1 row align-center justify-center>
                      <span class="grey--text">No Specified Hours</span>
                    </v-layout>
                  </v-card>

                  <!-- CERTIFICATIONS CARD -->
                  <v-card
                    v-if="
                      school.cpr === true ||
                        school.basic_life_support === true ||
                        school.acls === true
                    "
                    class="mt-4  pb-2 elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout class="red pb-2 justify-center">
                      <span class="white--text text-center mt-2"
                        >Certifications Required</span
                      >
                    </v-layout>

                    <v-card-text class="pt-2 pb-1">
                      <!-- CPR -->
                      <v-layout
                        v-if="school.cpr === true"
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text ">CPR</span>
                        <v-icon color="red" class="" size="20px"
                          >mdi-check-circle</v-icon
                        >
                      </v-layout>
                      <v-divider
                        v-if="school.cpr === true"
                        class="mt-2 mb-1 "
                      ></v-divider>

                      <!-- BLS -->
                      <v-layout
                        v-if="school.basic_life_support === true"
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text ">BLS</span>
                        <v-icon color="red" class="" size="20px"
                          >mdi-check-circle</v-icon
                        >
                      </v-layout>
                      <v-divider
                        v-if="school.basic_life_support === true"
                        class="mt-2 mb-1 "
                      ></v-divider>

                      <!-- ACLS -->
                      <v-layout
                        v-if="school.acls === true"
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text "
                          >ACLS</span
                        >
                        <v-icon color="red" class="" size="20px"
                          >mdi-check-circle</v-icon
                        >
                      </v-layout>
                      <v-divider
                        v-if="school.acls === true"
                        class="mt-2 mb-1 "
                      ></v-divider>
                    </v-card-text>
                  </v-card>

                  <!-- Average Healthcare Experience accepted previous Year -->
                  <v-card
                    v-if="
                      school.healthcare_experience_average_accepted_previous_year !==
                        '' &&
                        school.healthcare_experience_average_accepted_previous_year !==
                          undefined
                    "
                    class="mt-4 elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout justify-center class=" green pb-2 ">
                      <span block flat class=" white--text mt-2"
                        >Avg. Hours Accepted Prior Cycle</span
                      >
                    </v-layout>

                    <v-card-text class="pb-0 pt-1">
                      <v-layout
                        v-if="
                          school.healthcare_experience_average_accepted_previous_year !==
                            '' &&
                            school.healthcare_experience_average_accepted_previous_year !==
                              undefined
                        "
                        mt-2
                        mb-2
                        column
                        align-center
                        justify-center
                      >
                        <v-progress-circular
                          :width="3"
                          size="80"
                          :value="100"
                          color="grey"
                        >
                          <span
                            class="percentageValue headline font-weight-medium green--text"
                            >{{
                              school.healthcare_experience_average_accepted_previous_year
                            }}</span
                          ></v-progress-circular
                        >
                        <span class="black--text font-weight-light mt-1"
                          >Hours</span
                        >
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <!-- Healthcare Notes -->
                  <v-card
                    v-if="school.healthcareNotes"
                    outlined
                    class=" mt-4 mb-4"
                  >
                    <v-layout align-center justify-center class=" pb-1">
                      <v-icon small class="mr-2"
                        >mdi-message-text-outline</v-icon
                      >
                      <span class="font-weight-light align-center"
                        >Additional Notes
                      </span>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-text class="text-center">
                      <span>{{ school.healthcareNotes }}</span>
                    </v-card-text>
                  </v-card>

                  <div class="Competition__full">
                    <a
                      href="https://courses.healthcareercerts.org/?utm_source=mypabox&utm_medium=banner&utm_campaign=mypabox100&utm_id=Partnership"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        class="responsiveImage"
                        src="@/assets/PCEHours.png"
                      />
                    </a>
                  </div>
                  <v-btn
                    href="https://courses.healthcareercerts.org/?utm_source=mypabox&utm_medium=banner&utm_campaign=mypabox100&utm_id=Partnership"
                    color="primary"
                    large
                    class="no_border_radius"
                    target="_blank"
                    rel="noopener noreferrer"
                    >Click To Get Started</v-btn
                  >
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- PA Shadowing Hours -->
          <v-expansion-panels focusable class="px-2">
            <v-expansion-panel class="mt-4">
              <v-expansion-panel-header class="light-blue--text text--darken-4">
                <v-layout row align-center>
                  <v-icon color="blue darken-3">mdi-account-multiple</v-icon>
                  <span
                    class="ml-2 blue--text text--darken-3 font-weight-medium"
                    >PA Shadowing</span
                  >
                </v-layout>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="px-0 mx-0 pb-0 elevation-0">
                <!-- PA Shadowing Information -->
                <v-layout column>
                  <v-card class="elevation-0 innerCardCover " outlined>
                    <v-layout
                      v-if="school.pa_shadowing_required === true"
                      class="red pb-2 justify-center"
                    >
                      <span class="white--text text-center mt-2"
                        >PA Shadowing Required</span
                      >
                    </v-layout>
                    <v-layout
                      v-if="school.pa_shadowing_recommended === true"
                      class="amber darken-3 pb-2 justify-center"
                    >
                      <span class="white--text text-center mt-2"
                        >PA Shadowing Recommended</span
                      >
                    </v-layout>
                    <v-layout
                      v-if="
                        school.pa_shadowing_required === false &&
                          school.pa_shadowing_recommended === false
                      "
                      class="grey pb-2 justify-center"
                    >
                      <span class="white--text text-center mt-2"
                        >PA Shadowing Not Required</span
                      >
                    </v-layout>

                    <v-layout
                      v-if="school.pa_shadowing_required === true"
                      mt-4
                      mb-2
                      column
                      align-center
                      justify-center
                    >
                      <v-progress-circular
                        v-if="school.pa_shadowing_minimum_hours !== ''"
                        :width="3"
                        size="80"
                        :value="100"
                        color="grey"
                      >
                        <span
                          class="percentageValue headline font-weight-medium red--text"
                          >{{ school.pa_shadowing_minimum_hours }}</span
                        ></v-progress-circular
                      >
                      <span
                        v-if="school.pa_shadowing_minimum_hours === ''"
                        class="  mb-0  body-1 font-weight-light "
                        >No Specified Hours</span
                      >
                      <span
                        v-if="school.pa_shadowing_minimum_hours !== ''"
                        class="mt-1   font-weight-light"
                        >Hours</span
                      >
                    </v-layout>

                    <v-layout
                      v-if="school.pa_shadowing_recommended === true"
                      mt-4
                      mb-2
                      column
                      align-center
                      justify-center
                    >
                      <v-progress-circular
                        v-if="
                          school.pa_shadowing_recommended_minimum_hours !==
                            '' &&
                            school.pa_shadowing_recommended_minimum_hours !==
                              undefined
                        "
                        :width="3"
                        size="80"
                        :value="100"
                        color="grey"
                      >
                        <span
                          class="percentageValue headline font-weight-medium amber--text text--darken-3"
                          >{{
                            school.pa_shadowing_recommended_minimum_hours
                          }}</span
                        ></v-progress-circular
                      >
                      <span
                        v-if="
                          school.pa_shadowing_recommended_minimum_hours ===
                            '' ||
                            school.pa_shadowing_recommended_minimum_hours ===
                              undefined
                        "
                        class="  mb-0  body-1 font-weight-light "
                        >No Specified Hours</span
                      >
                      <span
                        v-if="
                          school.pa_shadowing_recommended_minimum_hours !==
                            '' &&
                            school.pa_shadowing_recommended_minimum_hours !==
                              undefined
                        "
                        class="mt-1   font-weight-light"
                        >Hours</span
                      >
                    </v-layout>
                  </v-card>

                  <v-alert
                    type="info"
                    v-if="!checkUserLoggedIn || !checkUserIsSubscribed"
                    class="mt-3"
                  >
                    <v-row class="d-sm-flex flex-column flex-lg-row">
                      <v-col
                        v-if="school.pa_shadowing_required"
                        class="grow pt-0"
                      >
                        Do you meet the minimum PA shadowing requirement for
                        this school?
                        <span v-if="!checkUserLoggedIn"> Sign up </span>
                        <span v-else-if="!checkUserIsSubscribed">
                          Subscribe</span
                        >
                        to keep track of all your PA shadowing in the "PA
                        Shadowing" section of your dashboard to see if you
                        qualify for this program.
                      </v-col>
                      <v-col
                        v-if="school.pa_shadowing_recommended"
                        class="grow pt-0"
                      >
                        Even though this program recommends PA shadowing hours,
                        it is strongly suggested you gain shadowing hours before
                        applying.
                        <span v-if="!checkUserLoggedIn"> Sign up </span>
                        <span v-else-if="!checkUserIsSubscribed">
                          Subscribe</span
                        >
                        to keep track of all your PA shadowing in the "PA
                        Shadowing" section of your dashboard to see if you
                        qualify for this program.
                      </v-col>
                      <v-col
                        v-if="
                          !school.pa_shadowing_required &&
                            !school.pa_shadowing_recommended
                        "
                        class="grow pt-0"
                      >
                        Even though this program does not require PA shadowing
                        hours, it is strongly suggested you gain shadowing hours
                        before applying.
                        <span v-if="!checkUserLoggedIn"> Sign up </span>
                        <span v-else-if="!checkUserIsSubscribed">
                          Subscribe</span
                        >
                        to keep track of all your PA shadowing in the "PA
                        Shadowing" section of your dashboard.
                      </v-col>
                      <v-col class="shrink">
                        <v-btn v-if="!checkUserLoggedIn" to="/LoginSignupPage"
                          >Sign Up</v-btn
                        >
                        <v-btn
                          v-else-if="!checkUserIsSubscribed"
                          to="/LoginSignupPage"
                          >Subscribe</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-alert>

                  <!-- Average PA Shadowing Hours accepted previous Year -->
                  <v-card
                    v-if="
                      school.pa_shadowing_average_accepted_previous_year !==
                        '' &&
                        school.pa_shadowing_average_accepted_previous_year !==
                          undefined
                    "
                    class="mt-4 elevation-0 "
                    style="borderRadius:5px"
                    outlined
                  >
                    <v-layout justify-center class=" green pb-2 ">
                      <span block class=" white--text mt-2"
                        >Avg. Hours Accepted Prior Cycle</span
                      >
                    </v-layout>

                    <v-card-text class="pb-0 pt-1">
                      <v-layout
                        v-if="
                          school.pa_shadowing_average_accepted_previous_year !==
                            '' &&
                            school.pa_shadowing_average_accepted_previous_year !==
                              undefined
                        "
                        mt-2
                        mb-2
                        column
                        align-center
                        justify-center
                      >
                        <v-progress-circular
                          :width="3"
                          size="80"
                          :value="100"
                          color="grey"
                        >
                          <span
                            class="percentageValue headline font-weight-medium green--text"
                            >{{
                              school.pa_shadowing_average_accepted_previous_year
                            }}</span
                          ></v-progress-circular
                        >
                        <span class="black--text font-weight-light mt-1"
                          >Hours</span
                        >
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <!-- PA Shadowing Notes -->
                  <v-card
                    v-if="school.paShadowingNotes"
                    outlined
                    class=" mt-4 mb-4"
                  >
                    <v-layout align-center justify-center class=" pb-1">
                      <v-icon small class="mr-2"
                        >mdi-message-text-outline</v-icon
                      >
                      <span class="font-weight-light align-center"
                        >Additional Notes
                      </span>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-text class="text-center">
                      <span>{{ school.paShadowingNotes }}</span>
                    </v-card-text>
                  </v-card>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Evaluations -->
          <v-expansion-panels focusable class="px-2">
            <v-expansion-panel class="mt-4">
              <v-expansion-panel-header class="light-blue--text text--darken-4">
                <v-layout row align-center>
                  <v-icon color="blue darken-3">mdi-account-voice</v-icon>
                  <span
                    class="ml-2 blue--text text--darken-3 font-weight-medium"
                    >Evaluations</span
                  >
                </v-layout>
              </v-expansion-panel-header>
              <v-expansion-panel-content class=" px-0 mx-0 pb-0 elevation-0">
                <!-- Evaluations Information -->
                <v-layout column>
                  <!-- Required Evaluations -->
                  <v-card class="elevation-0 innerCardCover" outlined>
                    <v-layout
                      v-if="school.letter_of_recommendation_required"
                      class="red pb-2 justify-center"
                    >
                      <span class="white--text text-center mt-2"
                        >Evaluations Required</span
                      >
                    </v-layout>
                    <v-layout
                      v-else-if="school.letter_of_recommendation_recommended"
                      class="amber darken-3 pb-2 justify-center"
                    >
                      <span class="white--text text-center mt-2"
                        >Evaluations Recommended</span
                      >
                    </v-layout>
                    <v-layout v-else class="grey pb-2 justify-center">
                      <span class="white--text text-center mt-2"
                        >Evaluations Not Required</span
                      >
                    </v-layout>

                    <v-layout
                      v-if="school.letter_of_recommendation_required"
                      mt-4
                      mb-2
                      column
                      align-center
                      justify-center
                    >
                      <v-progress-circular
                        v-if="
                          school.letter_of_recommendation_minimum_letters_required !==
                            ''
                        "
                        :width="3"
                        size="80"
                        :value="100"
                        color="grey"
                      >
                        <span
                          class="percentageValue headline font-weight-medium red--text"
                          >{{
                            school.letter_of_recommendation_minimum_letters_required
                          }}</span
                        ></v-progress-circular
                      >
                      <span
                        v-if="
                          school.letter_of_recommendation_minimum_letters_required ===
                            ''
                        "
                        class="  mb-0  body-1 font-weight-light "
                        >No Specified Evaluations Listed</span
                      >
                      <span
                        v-if="
                          school.letter_of_recommendation_minimum_letters_required !==
                            ''
                        "
                        class="mt-1   font-weight-light"
                        >Evaluations</span
                      >
                    </v-layout>

                    <v-layout
                      v-if="school.letter_of_recommendation_recommended"
                      mt-4
                      mb-2
                      column
                      align-center
                      justify-center
                    >
                      <v-progress-circular
                        v-if="
                          school.letter_of_recommendation_minimum_letters_required !==
                            ''
                        "
                        :width="3"
                        size="80"
                        :value="100"
                        color="grey"
                      >
                        <span
                          class="percentageValue headline font-weight-medium amber--text text--darken-3"
                          >{{
                            school.letter_of_recommendation_minimum_letters_required
                          }}</span
                        ></v-progress-circular
                      >
                      <span
                        v-if="
                          school.letter_of_recommendation_minimum_letters_required ===
                            ''
                        "
                        class="  mb-0  body-1 font-weight-light "
                        >No Specified Evaluations Listed</span
                      >
                      <span
                        v-if="
                          school.letter_of_recommendation_minimum_letters_required !==
                            ''
                        "
                        class="mt-1   font-weight-light"
                        >Evaluations</span
                      >
                    </v-layout>
                  </v-card>

                  <v-alert
                    type="info"
                    v-if="!checkUserLoggedIn || !checkUserIsSubscribed"
                    class="mt-5"
                  >
                    <v-row
                      class="d-sm-flex flex-column flex-lg-row"
                      align="center"
                    >
                      <v-col
                        v-if="
                          school.letter_of_recommendation_required ||
                            !school.letter_of_recommendation_required ||
                            school.letter_of_recommendation_recommended
                        "
                        class="grow pt-0"
                      >
                        <span v-if="!checkUserLoggedIn"> Sign up </span>
                        <span v-else-if="!checkUserIsSubscribed">
                          Subscribe</span
                        >
                        to keep track of all your evaluations in the
                        "Evaluations" section of your dashboard to see if you
                        qualify for this program.
                      </v-col>

                      <v-col class="shrink">
                        <v-btn v-if="!checkUserLoggedIn" to="/LoginSignupPage"
                          >Sign Up</v-btn
                        >
                        <v-btn
                          v-else-if="!checkUserIsSubscribed"
                          to="/LoginSignupPage"
                          >Subscribe</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-alert>

                  <!-- Specific Writers -->
                  <v-card
                    v-if="school.letter_of_recommendation_required"
                    class="mt-4 elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout
                      v-if="
                        school.letter_of_recommendation_specific_writers_required
                      "
                      class="grey lighten-3 pb-2 justify-center"
                    >
                      <span class="red--text text-center mt-2"
                        >Specific Evaluators Required</span
                      >
                    </v-layout>
                    <v-layout
                      v-if="
                        school.letter_of_recommendation_specific_writers_preferred
                      "
                      class="grey lighten-3 pb-2 justify-center"
                    >
                      <span class="amber--text text--darken-3 text-center mt-2"
                        >Specific Evaluators Preferred</span
                      >
                    </v-layout>
                    <v-layout
                      v-if="
                        school.letter_of_recommendation_specific_writers_required ===
                          false &&
                          school.letter_of_recommendation_specific_writers_preferred ===
                            false
                      "
                      class="grey  pb-2 justify-center"
                    >
                      <span class=" text-center mt-2 white--text"
                        >Specific Evaluators Not Required</span
                      >
                    </v-layout>

                    <v-card-text
                      v-if="
                        school
                          .letter_of_recommendation_specific_writers_title[0] !==
                          0 ||
                          (school.letter_of_recommendation_specific_writers_required ===
                            true ||
                            school.letter_of_recommendation_specific_writers_preferred ===
                              true)
                      "
                      class="pt-2  "
                    >
                      <v-layout
                        v-if="
                          school
                            .letter_of_recommendation_specific_writers_title[0] !==
                            0
                        "
                        v-for="writer in school.letter_of_recommendation_specific_writers_title"
                        :key="writer.id"
                        column
                        class="pl-0 ml-0 "
                      >
                        <v-layout
                          mt-2
                          row
                          align-center
                          justify-space-between
                          mx-0
                        >
                          <span class=" font-weight-light black--text ">{{
                            writer.writer_title
                          }}</span>
                          <v-icon
                            :color="
                              getIconColor(
                                school.letter_of_recommendation_specific_writers_required,
                                school.letter_of_recommendation_specific_writers_preferred
                              )
                            "
                            class=""
                            size="20px"
                            >mdi-check-circle</v-icon
                          >
                        </v-layout>
                        <span
                          v-if="writer.writer_timeframe_month"
                          class="grey--text"
                          >Minimum Time Known:
                          <span
                            class="font-weight-regular blue--text text--darken-3"
                            >{{ writer.writer_timeframe_month }} months</span
                          ></span
                        >
                        <span
                          v-if="writer.writer_timeframe_year"
                          class="grey--text"
                          >Minimum Time Known:
                          <span
                            class="font-weight-regular blue--text text--darken-3"
                            >{{ writer.writer_timeframe_year }} year(s)</span
                          ></span
                        >
                        <v-divider class="mt-2 mb-1 "></v-divider>
                      </v-layout>

                      <!-- Either One of the following Writers Needed -->
                      <v-layout
                        column
                        v-if="
                          school
                            .letter_of_recommendation_either_writers_title[0] !==
                            0
                        "
                      >
                        <v-subheader class="font-weight-regular text-center">
                          <v-layout
                            v-if="
                              school.letter_of_recommendation_specific_writers_required ===
                                true
                            "
                            justify-center
                            class="red--text"
                            >ONE of the following evaluators needed</v-layout
                          >
                          <v-layout
                            v-if="
                              school.letter_of_recommendation_specific_writers_preferred ===
                                true
                            "
                            justify-center
                            class="amber--text text--darken-3"
                            >Either of the following evaluators
                            preferred</v-layout
                          >
                        </v-subheader>
                        <v-layout
                          v-for="writer in school.letter_of_recommendation_either_writers_title"
                          :key="writer.id"
                          column
                          class="pl-0 ml-0 "
                        >
                          <v-layout row align-center justify-space-between mx-0>
                            <span class=" font-weight-light black--text ">{{
                              writer.writer_title
                            }}</span>
                            <v-icon
                              :color="
                                getIconColor(
                                  school.letter_of_recommendation_specific_writers_required,
                                  school.letter_of_recommendation_specific_writers_preferred
                                )
                              "
                              class=""
                              size="20px"
                              >mdi-check-circle</v-icon
                            >
                          </v-layout>
                          <span
                            v-if="writer.writer_timeframe_month"
                            class="grey--text"
                            >Minimum Time Known:
                            <span
                              class="font-weight-regular blue--text text--darken-3"
                              >{{ writer.writer_timeframe_month }} months</span
                            ></span
                          >
                          <span
                            v-if="writer.writer_timeframe_year"
                            class="grey--text"
                            >Minimum Time Known:
                            <span
                              class="font-weight-regular blue--text text--darken-3"
                              >{{ writer.writer_timeframe_year }} year(s)</span
                            ></span
                          >
                          <v-divider class="mt-2 mb-1 "></v-divider>
                        </v-layout>
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <!-- Required Evaluations Notes -->
                  <v-card
                    v-if="school.evaluationsNotes"
                    outlined
                    class=" mt-4 mb-4"
                  >
                    <v-layout align-center justify-center class=" pb-1">
                      <v-icon small class="mr-2"
                        >mdi-message-text-outline</v-icon
                      >
                      <span class="font-weight-light align-center"
                        >Additional Notes
                      </span>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-text class="text-center">
                      <span>{{ school.evaluationsNotes }}</span>
                    </v-card-text>
                  </v-card>

                  <!-- Recommended Evaluation Notes -->
                  <v-card
                    v-if="school.recommendedEvaluationsNotes"
                    outlined
                    class=" mt-4 mb-4"
                  >
                    <v-layout align-center justify-center class=" pb-1">
                      <v-icon small class="mr-2"
                        >mdi-message-text-outline</v-icon
                      >
                      <span class="font-weight-light align-center"
                        >Additional Notes
                      </span>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-text class="text-center">
                      <span>{{ school.recommendedEvaluationsNotes }}</span>
                    </v-card-text>
                  </v-card>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- GRE -->
          <v-expansion-panels focusable class="px-2">
            <v-expansion-panel class="mt-4">
              <v-expansion-panel-header class="light-blue--text text--darken-4">
                <v-layout row align-center>
                  <v-icon color="blue darken-3">mdi-file-document</v-icon>
                  <span
                    class="ml-2 blue--text text--darken-3 font-weight-medium"
                    >GRE</span
                  >
                </v-layout>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="px-0 mx-0 pb-0 elevation-0">
                <!-- GRE Information -->
                <v-layout column>
                  <v-card class="elevation-0 innerCardCover" outlined>
                    <v-layout
                      v-if="school.gre_required === true"
                      class="red pb-2 justify-center"
                    >
                      <span class="white--text text-center mt-2"
                        >GRE Required</span
                      >
                    </v-layout>
                    <v-layout v-else class="grey pb-2 justify-center">
                      <span class="white--text text-center mt-2"
                        >GRE Not Required</span
                      >
                    </v-layout>

                    <v-layout
                      v-if="school.gre_required === true"
                      mt-3
                      mb-3
                      align-center
                      justify-center
                    >
                      <!-- GRE INSTITUTION CODE -->
                      <v-layout
                        v-if="school.gre_instituition_code !== ''"
                        column
                        align-center
                        justify-center
                      >
                        <span
                          class="  mb-0  display-1 font-weight-regular blue--text text--darken-3"
                          >{{ school.gre_instituition_code }}</span
                        >
                        <span class="mt-1 caption font-weight-light black--text"
                          >Instituition Code</span
                        >
                      </v-layout>

                      <!-- CASPA INSTITUITION CODE -->
                      <v-layout
                        v-if="
                          school.caspa_gre_instituition_code !== '' &&
                            school.caspa_gre_instituition_code !== undefined
                        "
                        column
                        align-center
                        justify-center
                      >
                        <span
                          class="  mb-0  display-1 font-weight-regular blue--text text--darken-3"
                          >{{ school.caspa_gre_instituition_code }}</span
                        >
                        <span class="mt-1 caption font-weight-light black--text"
                          >CASPA Instituition Code</span
                        >
                      </v-layout>

                      <!-- INSTITUITION CODE NOT LISTED -->
                      <v-layout
                        v-if="
                          school.gre_instituition_code === '' &&
                            (school.caspa_gre_instituition_code === '' ||
                              school.caspa_gre_instituition_code === undefined)
                        "
                        align-center
                        justify-center
                      >
                        <span class="font-weight-light black--text"
                          >Instituition Code Not Listed</span
                        >
                      </v-layout>
                    </v-layout>
                  </v-card>

                  <!-- MINIMUM GRE SCORE -->
                  <v-card
                    v-if="school.gre_required === true"
                    class="mt-0 innerCardCover elevation-0"
                    outlined
                  >
                    <v-layout
                      v-if="
                        (school.gre_minimum_verbal_score !== '' &&
                          school.gre_minimum_verbal_score !== undefined &&
                          school.gre_minimum_verbal_score !== 0) ||
                          (school.gre_minimum_quantitative_score !== '' &&
                            school.gre_minimum_quantitative_score !==
                              undefined &&
                            school.gre_minimum_quantitative_score !== 0) ||
                          (school.gre_minimum_writing_score !== '' &&
                            school.gre_minimum_writing_score !== undefined &&
                            school.gre_minimum_writing_score !== 0) ||
                          (school.gre_minimum_combined_score !== '' &&
                            school.gre_minimum_combined_score !== undefined &&
                            school.gre_minimum_combined_score !== 0)
                      "
                      class="grey lighten-3 pb-2 justify-center"
                    >
                      <span class="red--text text-center mt-2"
                        >Minimum Scores Required</span
                      >
                    </v-layout>
                    <v-layout v-else class="grey pb-2 justify-center">
                      <span class="white--text text-center mt-2"
                        >Minimum Raw Scores Not Required</span
                      >
                    </v-layout>

                    <v-card-text
                      v-if="
                        (school.gre_minimum_verbal_score !== '' &&
                          school.gre_minimum_verbal_score !== undefined &&
                          school.gre_minimum_verbal_score !== 0) ||
                          (school.gre_minimum_quantitative_score !== '' &&
                            school.gre_minimum_quantitative_score !==
                              undefined &&
                            school.gre_minimum_quantitative_score !== 0) ||
                          (school.gre_minimum_writing_score !== '' &&
                            school.gre_minimum_writing_score !== undefined &&
                            school.gre_minimum_writing_score !== 0) ||
                          (school.gre_minimum_combined_score !== '' &&
                            school.gre_minimum_combined_score !== undefined &&
                            school.gre_minimum_combined_score !== 0)
                      "
                      class="pt-2"
                    >
                      <!-- COMBINED SCORE -->
                      <v-layout
                        v-if="
                          school.gre_minimum_combined_score !== '' &&
                            school.gre_minimum_combined_score !== undefined
                        "
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text "
                          >Combined</span
                        >
                        <span class="ml-4 blue--text text--darken-3 ">
                          {{ school.gre_minimum_combined_score }}</span
                        >
                      </v-layout>
                      <v-divider
                        v-if="
                          school.gre_minimum_combined_score !== '' &&
                            school.gre_minimum_combined_score !== undefined
                        "
                        class="mt-2 mb-1 "
                      ></v-divider>

                      <!-- VERBAL SCORE -->
                      <v-layout
                        v-if="
                          school.gre_minimum_verbal_score !== '' &&
                            school.gre_minimum_verbal_score !== undefined
                        "
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text "
                          >Verbal</span
                        >
                        <span class="ml-4 blue--text text--darken-3 ">
                          {{ school.gre_minimum_verbal_score }}</span
                        >
                      </v-layout>
                      <v-divider
                        v-if="
                          school.gre_minimum_verbal_score !== '' &&
                            school.gre_minimum_verbal_score !== undefined
                        "
                        class="mt-2 mb-1 "
                      ></v-divider>

                      <!-- QUANTITATIVE SCORE -->
                      <v-layout
                        v-if="
                          school.gre_minimum_quantitative_score !== '' &&
                            school.gre_minimum_quantitative_score !== undefined
                        "
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text "
                          >Quantitative (Math)</span
                        >
                        <span class="ml-4 blue--text text--darken-3 ">
                          {{ school.gre_minimum_quantitative_score }}</span
                        >
                      </v-layout>
                      <v-divider
                        v-if="
                          school.gre_minimum_quantitative_score !== '' &&
                            school.gre_minimum_quantitative_score !== undefined
                        "
                        class="mt-2 mb-1 "
                      ></v-divider>

                      <!-- ANALYTICAL (WRITING) SCORE -->
                      <v-layout
                        v-if="
                          school.gre_minimum_writing_score !== '' &&
                            school.gre_minimum_writing_score !== undefined
                        "
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text "
                          >Analytical (Writing)</span
                        >
                        <span class="ml-4 blue--text text--darken-3 ">
                          {{ school.gre_minimum_writing_score }}</span
                        >
                      </v-layout>
                      <v-divider
                        v-if="
                          school.gre_minimum_writing_score !== '' &&
                            school.gre_minimum_writing_score !== undefined
                        "
                        class="mt-2 mb-1 "
                      ></v-divider>
                    </v-card-text>
                  </v-card>

                  <!-- MINIMUM GRE PERCENTILE SCORES -->
                  <v-card
                    v-if="
                      school.gre_required === true &&
                        ((school.gre_minimum_combined_percentile !== '' &&
                          school.gre_minimum_combined_percentile !==
                            undefined) ||
                          (school.gre_minimum_verbal_percentile !== '' &&
                            school.gre_minimum_verbal_percentile !==
                              undefined) ||
                          (school.gre_minimum_quantitative_percentile !== '' &&
                            school.gre_minimum_quantitative_percentile !==
                              undefined) ||
                          (school.gre_minimum_writing_percentile !== '' &&
                            school.gre_minimum_writing_percentile !==
                              undefined))
                    "
                    class="mt-0 innerCardCover elevation-0"
                    outlined
                  >
                    <v-layout class="grey lighten-3 pb-2 justify-center">
                      <span class="red--text text-center mt-2"
                        >Minimum Percentile Scores Required</span
                      >
                    </v-layout>

                    <v-card-text class="pt-2">
                      <!-- COMBINED Percentile -->
                      <v-layout
                        v-if="
                          school.gre_minimum_combined_percentile !== '' &&
                            school.gre_minimum_combined_percentile !== undefined
                        "
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text "
                          >Combined</span
                        >
                        <span class="ml-4 blue--text text--darken-3 ">
                          {{ school.gre_minimum_combined_percentile }}%</span
                        >
                      </v-layout>
                      <v-divider
                        v-if="
                          school.gre_minimum_combined_percentile !== '' &&
                            school.gre_minimum_combined_percentile !== undefined
                        "
                        class="mt-2 mb-1 "
                      ></v-divider>

                      <!-- VERBAL Percentile -->
                      <v-layout
                        v-if="
                          school.gre_minimum_verbal_percentile !== '' &&
                            school.gre_minimum_verbal_percentile !== undefined
                        "
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text "
                          >Verbal</span
                        >
                        <span class="ml-4 blue--text text--darken-3 ">
                          {{ school.gre_minimum_verbal_percentile }}%</span
                        >
                      </v-layout>
                      <v-divider
                        v-if="
                          school.gre_minimum_verbal_percentile !== '' &&
                            school.gre_minimum_verbal_percentile !== undefined
                        "
                        class="mt-2 mb-1 "
                      ></v-divider>

                      <!-- QUANTITATIVE Percentile -->
                      <v-layout
                        v-if="
                          school.gre_minimum_quantitative_percentile !== '' &&
                            school.gre_minimum_quantitative_percentile !==
                              undefined
                        "
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text "
                          >Quantitative (Math)</span
                        >
                        <span class="ml-4 blue--text text--darken-3 ">
                          {{
                            school.gre_minimum_quantitative_percentile
                          }}%</span
                        >
                      </v-layout>
                      <v-divider
                        v-if="
                          school.gre_minimum_quantitative_percentile !== '' &&
                            school.gre_minimum_quantitative_percentile !==
                              undefined
                        "
                        class="mt-2 mb-1 "
                      ></v-divider>

                      <!-- ANALYTICAL (WRITING) SCORE -->
                      <v-layout
                        v-if="
                          school.gre_minimum_writing_percentile !== '' &&
                            school.gre_minimum_writing_percentile !== undefined
                        "
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text "
                          >Analytical (Writing)</span
                        >
                        <span class="ml-4 blue--text text--darken-3 ">
                          {{ school.gre_minimum_writing_percentile }}%</span
                        >
                      </v-layout>
                      <v-divider
                        v-if="
                          school.gre_minimum_writing_percentile !== '' &&
                            school.gre_minimum_writing_percentile !== undefined
                        "
                        class="mt-2 mb-1 "
                      ></v-divider>
                    </v-card-text>
                  </v-card>

                  <!-- GRE Conditions -->
                  <v-card
                    v-if="
                      school.gre_required === true &&
                        school.gre_minimum_year_completed !== '' &&
                        school.gre_minimum_year_completed !== undefined
                    "
                    class="mt-0 innerCardCover elevation-0"
                    outlined
                  >
                    <v-layout justify-center class=" grey lighten-3 pb-2 ">
                      <span class="subtitle-1 mt-2 font-weight-regular ">
                        Conditions
                      </span>
                    </v-layout>

                    <v-card-text class="pt-2  ">
                      <v-layout column class="pl-0 ml-0 ">
                        <v-layout mt-2 row align-center mx-0>
                          <span class=" font-weight-light black--text "
                            >GRE must be completed within
                            <span
                              class="font-weight-medium blue--text text--darken-3"
                              >{{
                                school.gre_minimum_year_completed
                              }}
                              years</span
                            ></span
                          >
                        </v-layout>
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <!-- GRE Exemptions -->
                  <v-card
                    v-if="
                      school.gre_required === true &&
                        (school.mcat_accepted_instead_gre === true ||
                          school.gre_exempt_masters_doctoral_degrees === true)
                    "
                    class="mt-0 innerCardCover elevation-0 "
                    outlined
                  >
                    <v-layout justify-center class=" grey lighten-3 pb-2 ">
                      <span class="subtitle-1 mt-2 font-weight-regular">
                        Exemptions
                      </span>
                    </v-layout>

                    <v-card-text class="pt-2  ">
                      <v-layout column class="pl-0 ml-0 ">
                        <v-layout
                          v-if="school.mcat_accepted_instead_gre === true"
                          mt-2
                          row
                          align-center
                          justify-space-between
                          mx-0
                        >
                          <span class=" font-weight-light black--text "
                            >MCAT accepted in place of GRE</span
                          >
                        </v-layout>
                        <!-- MINIMUM MCAT Score -->
                        <v-layout
                          v-if="
                            school.mcat_minimum_score_required !== '' &&
                              school.mcat_minimum_score_required !== undefined
                          "
                          row
                          mt-1
                        >
                          <span class="ml-3  grey--text ">
                            Minimum MCAT Score:
                            <span
                              class="font-weight-medium blue--text text--darken-3"
                              >{{ school.mcat_minimum_score_required }}</span
                            >
                          </span>
                        </v-layout>
                        <v-divider
                          v-if="school.mcat_accepted_instead_gre === true"
                          class="mt-2 mb-1 "
                        ></v-divider>

                        <v-layout
                          v-if="
                            school.gre_exempt_masters_doctoral_degrees === true
                          "
                          mt-2
                          row
                          align-center
                          justify-space-between
                          mx-0
                        >
                          <span class="font-weight-light black--text"
                            >GRE exempt with Masters or Doctoral Degree
                          </span>
                        </v-layout>
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <!-- AVERAGE GRE SCORES ACCEPTED -->
                  <v-card
                    v-if="
                      (school.gre_required === true &&
                        (school.gre_average_combined_score_previous_year !==
                          '' &&
                          school.gre_average_combined_score_previous_year !==
                            undefined)) ||
                        (school.gre_average_written_score_previous_year !==
                          '' &&
                          school.gre_average_written_score_previous_year !==
                            undefined) ||
                        (school.gre_average_quantitative_score_previous_year !==
                          '' &&
                          school.gre_average_quantitative_score_previous_year !==
                            undefined) ||
                        (school.gre_average_verbal_score_previous_year !== '' &&
                          school.gre_average_verbal_score_previous_year !==
                            undefined)
                    "
                    class="mt-0 elevation-0 innerCardCover"
                  >
                    <v-layout class="green pb-2 justify-center">
                      <span class="white--text mt-2 text-center mt-2"
                        >Avg. GRE Scores Accepted Prior Cycle</span
                      >
                    </v-layout>

                    <v-card-text class="pt-2">
                      <!-- COMBINED AVERAGE SCORE -->
                      <v-layout
                        v-if="
                          school.gre_average_combined_score_previous_year !==
                            '' &&
                            school.gre_average_combined_score_previous_year !==
                              undefined
                        "
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text "
                          >Combined</span
                        >
                        <span class="ml-4 green--text ">
                          {{
                            school.gre_average_combined_score_previous_year
                          }}</span
                        >
                      </v-layout>
                      <v-divider
                        v-if="
                          school.gre_average_combined_score_previous_year !==
                            '' &&
                            school.gre_average_combined_score_previous_year !==
                              undefined
                        "
                        class="mt-2 mb-1 "
                      ></v-divider>

                      <!-- VERBAL SCORE -->
                      <v-layout
                        v-if="
                          school.gre_average_verbal_score_previous_year !==
                            '' &&
                            school.gre_average_verbal_score_previous_year !==
                              undefined
                        "
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text "
                          >Verbal</span
                        >
                        <span class="ml-4 green--text">
                          {{
                            school.gre_average_verbal_score_previous_year
                          }}</span
                        >
                      </v-layout>
                      <v-divider
                        v-if="
                          school.gre_average_verbal_score_previous_year !==
                            '' &&
                            school.gre_average_verbal_score_previous_year !==
                              undefined
                        "
                        class="mt-2 mb-1 "
                      ></v-divider>

                      <!-- QUANTITATIVE SCORE -->
                      <v-layout
                        v-if="
                          school.gre_average_quantitative_score_previous_year !==
                            ''
                        "
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text "
                          >Quantitative (Math)</span
                        >
                        <span class="ml-4 green--text ">
                          {{
                            school.gre_average_quantitative_score_previous_year
                          }}</span
                        >
                      </v-layout>
                      <v-divider
                        v-if="
                          school.gre_average_quantitative_score_previous_year !==
                            '' &&
                            school.gre_average_quantitative_score_previous_year !==
                              undefined
                        "
                        class="mt-2 mb-1 "
                      ></v-divider>

                      <!-- ANALYTICAL (WRITING) SCORE -->
                      <v-layout
                        v-if="
                          school.gre_average_written_score_previous_year !==
                            '' &&
                            school.gre_average_written_score_previous_year !==
                              undefined
                        "
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text "
                          >Analytical (Writing)</span
                        >
                        <span class="ml-4 green--text">
                          {{
                            school.gre_average_written_score_previous_year
                          }}</span
                        >
                      </v-layout>
                      <v-divider
                        v-if="
                          school.gre_average_written_score_previous_year !==
                            '' &&
                            school.gre_average_written_score_previous_year !==
                              undefined
                        "
                        class="mt-2 mb-1 "
                      ></v-divider>
                    </v-card-text>
                  </v-card>

                  <!-- AVERAGE GRE PERCENTILE SCORES ACCEPTED -->
                  <v-card
                    v-if="
                      (school.gre_required === true &&
                        (school.gre_average_combined_percentile_previous_year !==
                          '' &&
                          school.gre_average_combined_percentile_previous_year !==
                            undefined)) ||
                        (school.gre_average_written_percentile_previous_year !==
                          '' &&
                          school.gre_average_written_percentile_previous_year !==
                            undefined) ||
                        (school.gre_average_quantitative_percentile_previous_year !==
                          '' &&
                          school.gre_average_quantitative_percentile_previous_year !==
                            undefined) ||
                        (school.gre_average_verbal_percentile_previous_year !==
                          '' &&
                          school.gre_average_verbal_percentile_previous_year !==
                            undefined)
                    "
                    class="mt-0 innerCardCover elevation-0"
                    outlined
                  >
                    <v-layout class="green pb-2 justify-center">
                      <span class="white--text mt-2 text-center mt-2"
                        >Avg. GRE % Scores Accepted Prior Cycle</span
                      >
                    </v-layout>

                    <v-card-text class="pt-2">
                      <!-- COMBINED AVERAGE SCORE Percentile -->
                      <v-layout
                        v-if="
                          school.gre_average_combined_percentile_previous_year !==
                            '' &&
                            school.gre_average_combined_percentile_previous_year !==
                              undefined
                        "
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text "
                          >Combined</span
                        >
                        <span class="ml-4 green--text ">
                          {{
                            school.gre_average_combined_percentile_previous_year
                          }}%</span
                        >
                      </v-layout>
                      <v-divider
                        v-if="
                          school.gre_average_combined_percentile_previous_year !==
                            '' &&
                            school.gre_average_combined_percentile_previous_year !==
                              undefined
                        "
                        class="mt-2 mb-1 "
                      ></v-divider>

                      <!-- VERBAL Average SCORE Percentile -->
                      <v-layout
                        v-if="
                          school.gre_average_verbal_percentile_previous_year !==
                            '' &&
                            school.gre_average_verbal_percentile_previous_year !==
                              undefined
                        "
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text "
                          >Verbal</span
                        >
                        <span class="ml-4 green--text">
                          {{
                            school.gre_average_verbal_percentile_previous_year
                          }}%</span
                        >
                      </v-layout>
                      <v-divider
                        v-if="
                          school.gre_average_verbal_percentile_previous_year !==
                            '' &&
                            school.gre_average_verbal_percentile_previous_year !==
                              undefined
                        "
                        class="mt-2 mb-1 "
                      ></v-divider>

                      <!-- QUANTITATIVE SCORE -->
                      <v-layout
                        v-if="
                          school.gre_average_quantitative_percentile_previous_year !==
                            '' &&
                            school.gre_average_quantitative_percentile_previous_year !==
                              undefined
                        "
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text "
                          >Quantitative (Math)</span
                        >
                        <span class="ml-4 green--text ">
                          {{
                            school.gre_average_quantitative_percentile_previous_year
                          }}%</span
                        >
                      </v-layout>
                      <v-divider
                        v-if="
                          school.gre_average_quantitative_percentile_previous_year !==
                            '' &&
                            school.gre_average_quantitative_percentile_previous_year !==
                              undefined
                        "
                        class="mt-2 mb-1 "
                      ></v-divider>

                      <!-- ANALYTICAL (WRITING) SCORE -->
                      <v-layout
                        v-if="
                          school.gre_average_written_percentile_previous_year !==
                            '' &&
                            school.gre_average_written_percentile_previous_year !==
                              undefined
                        "
                        mt-2
                        row
                        align-center
                        justify-space-between
                        mx-0
                      >
                        <span class=" font-weight-light black--text "
                          >Analytical (Writing)</span
                        >
                        <span class="ml-4 green--text">
                          {{
                            school.gre_average_written_percentile_previous_year
                          }}%</span
                        >
                      </v-layout>
                      <v-divider
                        v-if="
                          school.gre_average_written_percentile_previous_year !==
                            '' &&
                            school.gre_average_written_percentile_previous_year !==
                              undefined
                        "
                        class="mt-2 mb-1 "
                      ></v-divider>
                    </v-card-text>
                  </v-card>
                  <v-layout v-if="school.gre_required">
                    <v-alert
                      type="info"
                      v-if="!checkUserLoggedIn || !checkUserIsSubscribed"
                      class="mt-5"
                    >
                      <v-row
                        class="d-sm-flex flex-column flex-lg-row"
                        align="center"
                      >
                        <v-col class="grow pt-0">
                          <span v-if="!checkUserLoggedIn"> Sign up </span>
                          <span v-else-if="!checkUserIsSubscribed">
                            Subscribe</span
                          >
                          to keep track of all your required exams in the
                          "Exams" section of your dashboard to make sure you
                          qualify for this program.
                        </v-col>

                        <v-col class="shrink">
                          <v-btn v-if="!checkUserLoggedIn" to="/LoginSignupPage"
                            >Sign Up</v-btn
                          >
                          <v-btn
                            v-else-if="!checkUserIsSubscribed"
                            to="/LoginSignupPage"
                            >Subscribe</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-alert>
                  </v-layout>
                  <!-- GRE Notes -->
                  <v-card v-if="school.greNotes" outlined class=" mt-4 mb-4">
                    <v-layout align-center justify-center class=" pb-1">
                      <v-icon small class="mr-2"
                        >mdi-message-text-outline</v-icon
                      >
                      <span class="font-weight-light align-center"
                        >Additional Notes
                      </span>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-text class="text-center">
                      <span>{{ school.greNotes }}</span>
                    </v-card-text>
                  </v-card>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- CASPER -->
          <v-expansion-panels
            v-if="school.casper_accepted || school.casper_recommended"
            focusable
            class="px-2"
          >
            <v-expansion-panel class="mt-4">
              <v-expansion-panel-header class="light-blue--text text--darken-4">
                <v-layout row align-center>
                  <v-icon color="blue darken-3">mdi-file-document</v-icon>
                  <span
                    class="ml-2 blue--text text--darken-3 font-weight-medium"
                    >CASPer</span
                  >
                </v-layout>
              </v-expansion-panel-header>
              <v-expansion-panel-content class=" px-0 mx-0 pb-0 elevation-0">
                <!-- CASPER Information -->
                <v-layout column>
                  <!-- CASPer Required -->
                  <v-card
                    v-if="school.casper_accepted"
                    class="elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout class="red pb-2 justify-center">
                      <span class="white--text text-center mt-2"
                        >CASPer Required</span
                      >
                    </v-layout>

                    <v-card-text class="pt-0">
                      <v-layout mt-3 mb-3 align-center>
                        <span
                          >For more information on the CASPER exam click on the
                          following link.<a
                            class="ml-1"
                            href="https://takecasper.com/"
                            target="_blank"
                            >CASPer Exam
                          </a></span
                        >
                      </v-layout>
                    </v-card-text>
                  </v-card>
                  <!-- CASPER Recommended -->
                  <v-card
                    v-if="school.casper_recommended"
                    class="elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout class="amber darken-3 pb-2 justify-center">
                      <span class="white--text text-center mt-2"
                        >CASPer Recommended</span
                      >
                    </v-layout>

                    <v-card-text class="pt-0">
                      <v-layout mt-3 mb-3 align-center>
                        <span
                          >For more information on the CASPER exam click on the
                          following link.<a
                            class="ml-1"
                            href="https://takecasper.com/"
                            target="_blank"
                            >CASPer Exam
                          </a></span
                        >
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <v-alert
                    type="info"
                    v-if="!checkUserLoggedIn || !checkUserIsSubscribed"
                    class="mt-3"
                  >
                    <v-row
                      class="d-sm-flex flex-column flex-lg-row"
                      align="center"
                      v-if="school.casper_accepted || school.casper_recommended"
                    >
                      <v-col class="grow pt-0">
                        <span v-if="!checkUserLoggedIn"> Sign up </span>
                        <span v-else-if="!checkUserIsSubscribed">
                          Subscribe</span
                        >
                        to keep track of all your exams in the "Exams" section
                        of your dashboard to make sure you qualify for this
                        program.
                      </v-col>

                      <v-col class="shrink">
                        <v-btn v-if="!checkUserLoggedIn" to="/LoginSignupPage"
                          >Sign Up</v-btn
                        >
                        <v-btn
                          v-else-if="!checkUserIsSubscribed"
                          to="/LoginSignupPage"
                          >Subscribe</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-alert>

                  <!-- CASPer Notes -->
                  <v-card v-if="school.casperNotes" outlined class=" mt-4 mb-4">
                    <v-layout align-center justify-center class=" pb-1">
                      <v-icon small class="mr-2"
                        >mdi-message-text-outline</v-icon
                      >
                      <span class="font-weight-light align-center"
                        >Additional Notes
                      </span>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-text class="text-center">
                      <span>{{ school.casperNotes }}</span>
                    </v-card-text>
                  </v-card>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- PA-CAT -->
          <v-expansion-panels
            v-if="school.pacat_required || school.pacat_recommended"
            focusable
            class="px-2"
          >
            <v-expansion-panel class="mt-4">
              <v-expansion-panel-header class="light-blue--text text--darken-4">
                <v-layout row align-center>
                  <v-icon color="blue darken-3">mdi-file-document</v-icon>
                  <span
                    class="ml-2 blue--text text--darken-3 font-weight-medium"
                    >PA-CAT</span
                  >
                </v-layout>
              </v-expansion-panel-header>
              <v-expansion-panel-content class=" px-0 mx-0 pb-0 elevation-0">
                <v-layout column>
                  <!-- PA-CAT Required -->
                  <v-card
                    v-if="school.pacat_required"
                    class="elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout class="red pb-2 justify-center">
                      <span class="white--text text-center mt-2"
                        >PA-CAT Required</span
                      >
                    </v-layout>

                    <v-card-text class="pt-0">
                      <v-layout mt-3 mb-3 align-center>
                        <span
                          >For more information on the PA-CAT exam click on the
                          following link.<a
                            class="ml-1"
                            href="https://www.pa-cat.com/about-the-pa-cat/"
                            target="_blank"
                            >PA-CAT Exam
                          </a></span
                        >
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <!-- PA-CAT Recommended -->
                  <v-card
                    v-if="school.pacat_recommended"
                    class="elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout class="amber darken-3 pb-2 justify-center">
                      <span class="white--text text-center mt-2"
                        >PA-CAT Recommended</span
                      >
                    </v-layout>

                    <v-card-text class="pt-0">
                      <v-layout mt-3 mb-3 align-center>
                        <span
                          >For more information on the PA-CAT exam click on the
                          following link.<a
                            class="ml-1"
                            href="https://www.pa-cat.com/about-the-pa-cat/"
                            target="_blank"
                            >PA-CAT Exam
                          </a></span
                        >
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <v-alert
                    type="info"
                    v-if="!checkUserLoggedIn || !checkUserIsSubscribed"
                    class="mt-3"
                  >
                    <v-row
                      class="d-sm-flex flex-column flex-lg-row"
                      align="center"
                      v-if="school.pacat_required || school.pacat_recommended"
                    >
                      <v-col class="grow pt-0">
                        <span v-if="!checkUserLoggedIn"> Sign up </span>
                        <span v-else-if="!checkUserIsSubscribed">
                          Subscribe</span
                        >
                        to keep track of all your exams in the "Exams" section
                        of your dashboard to make sure you qualify for this
                        program.
                      </v-col>

                      <v-col class="shrink">
                        <v-btn v-if="!checkUserLoggedIn" to="/LoginSignupPage"
                          >Sign Up</v-btn
                        >
                        <v-btn
                          v-else-if="!checkUserIsSubscribed"
                          to="/LoginSignupPage"
                          >Subscribe</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-alert>

                  <!-- PACAT Notes -->
                  <v-card v-if="school.pacatNotes" outlined class=" mt-4 mb-4">
                    <v-layout align-center justify-center class=" pb-1">
                      <v-icon small class="mr-2"
                        >mdi-message-text-outline</v-icon
                      >
                      <span class="font-weight-light align-center"
                        >Additional Notes
                      </span>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-text class="text-center">
                      <span>{{ school.pacatNotes }}</span>
                    </v-card-text>
                  </v-card>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- International Students -->
          <v-expansion-panels
            v-if="
              school.accepts_international_students ||
                school.toefl_required ||
                school.ielts_required ||
                school.melab_required ||
                school.pteAcademic_required ||
                school.itepAcademicPlus_required
            "
            focusable
            class="px-2"
          >
            <v-expansion-panel class="mt-4">
              <v-expansion-panel-header class="light-blue--text text--darken-4">
                <v-layout row align-center>
                  <v-icon color="blue darken-3">mdi-earth</v-icon>
                  <span
                    class="ml-2 blue--text text--darken-3 font-weight-medium"
                    >International Students
                  </span>
                </v-layout>
              </v-expansion-panel-header>
              <v-expansion-panel-content class=" px-0 mx-0 pb-0 elevation-0">
                <!-- International Students Information -->
                <v-layout column>
                  <v-layout
                    v-if="school.accepts_international_students"
                    class="green mt-4 pb-2 justify-center"
                    style="borderRadius:5px"
                  >
                    <span class="white--text text-center mt-2"
                      >International Students Accepted</span
                    >
                  </v-layout>

                  <!-- Accepted English Proficiency Exams -->
                  <v-card
                    v-if="
                      school.toefl_required ||
                        school.ielts_required ||
                        school.melab_required ||
                        school.pteAcademic_required ||
                        school.itepAcademicPlus_required
                    "
                    class="mt-4 elevation-0 innerCardCover pb-4"
                    outlined
                  >
                    <v-layout class="red pb-2 justify-center">
                      <span class="white--text text-center mt-2"
                        >English Proficiency Exams Required
                      </span>
                    </v-layout>

                    <v-layout justify-center align-center
                      ><v-subheader class="subtitle-1">
                        Accepted Exams</v-subheader
                      ></v-layout
                    >

                    <!-- TOEFL IBT -->
                    <v-expansion-panels
                      v-if="school.toefl_required"
                      focusable
                      class="mt-1 px-2 elevation-0"
                    >
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <v-layout row align-center>
                            <span
                              class="ml-2 blue--text text--darken-3 font-weight-medium"
                              >TOEFL IBT</span
                            >
                          </v-layout>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content style="borderRadius:5px;">
                          <v-layout
                            v-if="
                              (school.toefl_minimum_computer_score === '' ||
                                school.toefl_minimum_computer_score ===
                                  undefined) &&
                                (school.toefl_ibt_minimum_reading_score ===
                                  '' ||
                                  school.toefl_ibt_minimum_reading_score ===
                                    undefined) &&
                                (school.toefl_ibt_minimum_writing_score ===
                                  '' ||
                                  school.toefl_ibt_minimum_writing_score ===
                                    undefined) &&
                                (school.toefl_ibt_minimum_listening_score ===
                                  '' ||
                                  school.toefl_ibt_minimum_listening_score ===
                                    undefined) &&
                                (school.toefl_ibt_minimum_speaking_score ===
                                  '' ||
                                  school.toefl_ibt_minimum_speaking_score ===
                                    undefined)
                            "
                            align-center
                            justify-center
                            py-2
                            class="grey--text white "
                          >
                            No Minimum Score Required
                          </v-layout>

                          <!-- MINIMUM TOEFL IBT SCORES -->
                          <v-layout
                            v-if="
                              (school.toefl_minimum_computer_score !== '' &&
                                school.toefl_minimum_computer_score !==
                                  undefined) ||
                                (school.toefl_ibt_minimum_reading_score !==
                                  '' &&
                                  school.toefl_ibt_minimum_reading_score !==
                                    undefined) ||
                                (school.toefl_ibt_minimum_writing_score !==
                                  '' &&
                                  school.toefl_ibt_minimum_writing_score !==
                                    undefined) ||
                                (school.toefl_ibt_minimum_listening_score !==
                                  '' &&
                                  school.toefl_ibt_minimum_listening_score !==
                                    undefined) ||
                                (school.toefl_ibt_minimum_speaking_score !==
                                  '' &&
                                  school.toefl_ibt_minimum_speaking_score !==
                                    undefined)
                            "
                            column
                            class="pl-0 ml-0 "
                          >
                            <v-layout
                              justify-center
                              align-center
                              class="pl-2 font-weight-regular red--text"
                            >
                              Minimum Scores Required
                            </v-layout>

                            <!-- Total Score -->
                            <v-layout
                              v-if="
                                school.toefl_minimum_computer_score !== '' &&
                                  school.toefl_minimum_computer_score !==
                                    undefined
                              "
                              mt-3
                              row
                              align-center
                              justify-space-between
                              mx-2
                            >
                              <span class=" font-weight-light black--text "
                                >Total Score</span
                              >
                              <span class=" blue--text text--darken-3 ">
                                {{ school.toefl_minimum_computer_score }}</span
                              >
                            </v-layout>
                            <v-divider
                              v-if="
                                school.toefl_minimum_computer_score !== '' &&
                                  school.toefl_minimum_computer_score !==
                                    undefined
                              "
                              class="mt-2 mb-1 mx-2"
                            ></v-divider>

                            <!-- Minimum IBT Reading Score -->
                            <v-layout
                              v-if="
                                school.toefl_ibt_minimum_reading_score !== '' &&
                                  school.toefl_ibt_minimum_reading_score !==
                                    undefined
                              "
                              mt-1
                              row
                              align-center
                              justify-space-between
                              mx-2
                            >
                              <span class=" font-weight-light black--text "
                                >Reading</span
                              >
                              <span class=" blue--text text--darken-3 ">
                                {{
                                  school.toefl_ibt_minimum_reading_score
                                }}</span
                              >
                            </v-layout>
                            <v-divider
                              v-if="
                                school.toefl_ibt_minimum_reading_score !== '' &&
                                  school.toefl_ibt_minimum_reading_score !==
                                    undefined
                              "
                              class="mt-2 mb-1 mx-2"
                            ></v-divider>

                            <!-- Minimum IBT Written Score -->
                            <v-layout
                              v-if="
                                school.toefl_ibt_minimum_writing_score !== '' &&
                                  school.toefl_ibt_minimum_writing_score !==
                                    undefined
                              "
                              mt-1
                              row
                              align-center
                              justify-space-between
                              mx-2
                            >
                              <span class=" font-weight-light black--text "
                                >Written</span
                              >
                              <span class=" blue--text text--darken-3 ">
                                {{
                                  school.toefl_ibt_minimum_writing_score
                                }}</span
                              >
                            </v-layout>
                            <v-divider
                              v-if="
                                school.toefl_ibt_minimum_writing_score !== '' &&
                                  school.toefl_ibt_minimum_writing_score !==
                                    undefined
                              "
                              class="mt-2 mb-1 mx-2"
                            ></v-divider>

                            <!-- Minimum IBT Listening Score -->
                            <v-layout
                              v-if="
                                school.toefl_ibt_minimum_listening_score !==
                                  '' &&
                                  school.toefl_ibt_minimum_listening_score !==
                                    undefined
                              "
                              mt-1
                              row
                              align-center
                              justify-space-between
                              mx-2
                            >
                              <span class=" font-weight-light black--text "
                                >Listening</span
                              >
                              <span class=" blue--text text--darken-3 ">
                                {{
                                  school.toefl_ibt_minimum_listening_score
                                }}</span
                              >
                            </v-layout>
                            <v-divider
                              v-if="
                                school.toefl_ibt_minimum_listening_score !==
                                  '' &&
                                  school.toefl_ibt_minimum_listening_score !==
                                    undefined
                              "
                              class="mt-2 mb-1 mx-2"
                            ></v-divider>

                            <!-- Minimum IBT Speaking Score -->
                            <v-layout
                              v-if="
                                school.toefl_ibt_minimum_speaking_score !==
                                  '' &&
                                  school.toefl_ibt_minimum_speaking_score !==
                                    undefined
                              "
                              mt-1
                              row
                              align-center
                              justify-space-between
                              mx-2
                            >
                              <span class=" font-weight-light black--text "
                                >Speaking</span
                              >
                              <span class=" blue--text text--darken-3 ">
                                {{
                                  school.toefl_ibt_minimum_speaking_score
                                }}</span
                              >
                            </v-layout>
                            <v-divider
                              v-if="
                                school.toefl_ibt_minimum_speaking_score !==
                                  '' &&
                                  school.toefl_ibt_minimum_speaking_score !==
                                    undefined
                              "
                              class="mt-2 mb-1 mx-2"
                            ></v-divider>
                          </v-layout>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>

                    <!-- TOEFL PBT -->
                    <v-expansion-panels
                      v-if="
                        (school.toefl_required &&
                          (school.toefl_minimum_written_score !== '' &&
                            school.toefl_minimum_written_score !==
                              undefined)) ||
                          (school.toefl_pbt_minimum_reading_score !== '' &&
                            school.toefl_pbt_minimum_reading_score !==
                              undefined) ||
                          (school.toefl_pbt_minimum_written_score !== '' &&
                            school.toefl_pbt_minimum_written_score !==
                              undefined) ||
                          (school.toefl_pbt_minimum_listening_score !== '' &&
                            school.toefl_pbt_minimum_listening_score !==
                              undefined)
                      "
                      class="mt-3 px-2 elevation-0"
                    >
                      <v-expansion-panel>
                        <v-expansion-panel-header class="py-1">
                          <v-layout row align-center>
                            <span
                              class="ml-2 blue--text text--darken-3 font-weight-medium"
                              >TOEFL PBT</span
                            >
                          </v-layout>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content style="borderRadius:5px;">
                          <v-layout
                            v-if="
                              (school.toefl_minimum_written_score === '' ||
                                school.toefl_minimum_written_score ===
                                  undefined) &&
                                (school.toefl_pbt_minimum_reading_score ===
                                  '' ||
                                  school.toefl_pbt_minimum_reading_score ===
                                    undefined) &&
                                (school.toefl_pbt_minimum_written_score ===
                                  '' ||
                                  school.toefl_pbt_minimum_written_score ===
                                    undefined) &&
                                (school.toefl_pbt_minimum_listening_score ===
                                  '' ||
                                  school.toefl_pbt_minimum_listening_score ===
                                    undefined)
                            "
                            align-center
                            justify-center
                            py-2
                            class="grey--text white "
                          >
                            No Minimum Score Required
                          </v-layout>

                          <!-- MINIMUM TOEFL PBT SCORES -->
                          <v-layout
                            v-if="
                              (school.toefl_minimum_written_score !== '' &&
                                school.toefl_minimum_written_score !==
                                  undefined) ||
                                (school.toefl_pbt_minimum_reading_score !==
                                  '' &&
                                  school.toefl_pbt_minimum_reading_score !==
                                    undefined) ||
                                (school.toefl_pbt_minimum_written_score !==
                                  '' &&
                                  school.toefl_pbt_minimum_written_score !==
                                    undefined) ||
                                (school.toefl_pbt_minimum_listening_score !==
                                  '' &&
                                  school.toefl_pbt_minimum_listening_score !==
                                    undefined)
                            "
                            column
                            class="pl-0 ml-0 "
                          >
                            <v-layout
                              justify-center
                              align-center
                              class="pl-2 font-weight-regular red--text"
                            >
                              Minimum Scores Required
                            </v-layout>

                            <!-- Minimum PBT Total score -->
                            <v-layout
                              v-if="
                                school.toefl_minimum_written_score !== '' &&
                                  school.toefl_minimum_written_score !==
                                    undefined
                              "
                              mt-3
                              row
                              align-center
                              justify-space-between
                              mx-2
                            >
                              <span class=" font-weight-light black--text "
                                >Total Score</span
                              >
                              <span class=" blue--text text--darken-3 ">
                                {{ school.toefl_minimum_written_score }}</span
                              >
                            </v-layout>
                            <v-divider
                              v-if="
                                school.toefl_minimum_written_score !== '' &&
                                  school.toefl_minimum_written_score !==
                                    undefined
                              "
                              class="mt-1 mb-1 mx-2"
                            ></v-divider>

                            <!-- Minimum PDT READING score -->
                            <v-layout
                              v-if="
                                school.toefl_pbt_minimum_reading_score !== '' &&
                                  school.toefl_pbt_minimum_reading_score !==
                                    undefined
                              "
                              mt-2
                              row
                              align-center
                              justify-space-between
                              mx-2
                            >
                              <span class=" font-weight-light black--text "
                                >Reading</span
                              >
                              <span class=" blue--text text--darken-3 ">
                                {{
                                  school.toefl_pbt_minimum_reading_score
                                }}</span
                              >
                            </v-layout>
                            <v-divider
                              v-if="
                                school.toefl_pbt_minimum_reading_score !== '' &&
                                  school.toefl_pbt_minimum_reading_score !==
                                    undefined
                              "
                              class="mt-1 mb-1 mx-2"
                            ></v-divider>

                            <!-- Minimum PDT WRITTEN score -->
                            <v-layout
                              v-if="
                                school.toefl_pbt_minimum_written_score !== '' &&
                                  school.toefl_pbt_minimum_written_score !==
                                    undefined
                              "
                              mt-2
                              row
                              align-center
                              justify-space-between
                              mx-2
                            >
                              <span class=" font-weight-light black--text "
                                >Written</span
                              >
                              <span class=" blue--text text--darken-3 ">
                                {{
                                  school.toefl_pbt_minimum_written_score
                                }}</span
                              >
                            </v-layout>
                            <v-divider
                              v-if="
                                school.toefl_pbt_minimum_written_score !== '' &&
                                  school.toefl_pbt_minimum_written_score !==
                                    undefined
                              "
                              class="mt-1 mb-1 mx-2"
                            ></v-divider>

                            <!-- Minimum PDT LISTENING score -->
                            <v-layout
                              v-if="
                                school.toefl_pbt_minimum_listening_score !==
                                  '' &&
                                  school.toefl_pbt_minimum_listening_score !==
                                    undefined
                              "
                              mt-2
                              row
                              align-center
                              justify-space-between
                              mx-2
                            >
                              <span class=" font-weight-light black--text "
                                >Listening</span
                              >
                              <span class=" blue--text text--darken-3 ">
                                {{
                                  school.toefl_pbt_minimum_listening_score
                                }}</span
                              >
                            </v-layout>
                            <v-divider
                              v-if="
                                school.toefl_pbt_minimum_listening_score !==
                                  '' &&
                                  school.toefl_pbt_minimum_listening_score !==
                                    undefined
                              "
                              class="mt-1 mb-1 mx-2"
                            ></v-divider>
                          </v-layout>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>

                    <!-- IELTS -->
                    <v-expansion-panels
                      v-if="school.ielts_required"
                      class="mt-3 px-2 elevation-0"
                    >
                      <v-expansion-panel>
                        <v-expansion-panel-header class="py-1">
                          <v-layout row align-center>
                            <span
                              class="ml-2 blue--text text--darken-3 font-weight-medium"
                              >IELTS</span
                            >
                          </v-layout>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content style="borderRadius:5px;">
                          <v-layout
                            v-if="
                              school.ielts_minimum_score === '' ||
                                school.ielts_minimum_score === undefined
                            "
                            align-center
                            justify-center
                            py-2
                            class="grey--text white"
                          >
                            No Minimum Score Required
                          </v-layout>

                          <v-layout
                            v-if="
                              school.ielts_minimum_score !== '' &&
                                school.ielts_minimum_score !== undefined
                            "
                            column
                            class="pl-0 ml-0 "
                          >
                            <v-layout
                              justify-center
                              align-center
                              class="pl-2 font-weight-regular red--text"
                            >
                              Minimum Scores Required
                            </v-layout>

                            <!-- Total score -->
                            <v-layout
                              v-if="
                                school.ielts_minimum_score !== '' &&
                                  school.ielts_minimum_score !== undefined
                              "
                              mt-3
                              row
                              align-center
                              justify-space-between
                              mx-2
                            >
                              <span class=" font-weight-light black--text "
                                >Total Score</span
                              >
                              <span class=" blue--text text--darken-3 ">
                                {{ school.ielts_minimum_score }}</span
                              >
                            </v-layout>
                            <v-divider
                              v-if="
                                school.ielts_minimum_score !== '' &&
                                  school.ielts_minimum_score !== undefined
                              "
                              class="mt-1 mb-1 mx-2"
                            ></v-divider>
                          </v-layout>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>

                    <!-- MELAB -->
                    <v-expansion-panels
                      v-if="school.melab_required"
                      class="mt-3 px-2 elevation-0"
                    >
                      <v-expansion-panel>
                        <v-expansion-panel-header class="py-1">
                          <v-layout row align-center>
                            <span
                              class="ml-2 blue--text text--darken-3 font-weight-medium"
                              >MELAB</span
                            >
                          </v-layout>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content style="borderRadius:5px;">
                          <v-layout
                            v-if="
                              school.melab_minimum_score === '' ||
                                school.melab_minimum_score === undefined
                            "
                            align-center
                            justify-center
                            py-2
                            class="grey--text white"
                          >
                            No Minimum Score Required
                          </v-layout>

                          <v-layout
                            v-if="
                              school.melab_minimum_score !== '' &&
                                school.melab_minimum_score !== undefined
                            "
                            column
                            class="pl-0 ml-0 "
                          >
                            <v-layout
                              justify-center
                              align-center
                              class="pl-2 font-weight-regular red--text"
                            >
                              Minimum Scores Required
                            </v-layout>

                            <!-- Total score -->
                            <v-layout
                              v-if="
                                school.melab_minimum_score !== '' &&
                                  school.melab_minimum_score !== undefined
                              "
                              mt-3
                              row
                              align-center
                              justify-space-between
                              mx-2
                            >
                              <span class=" font-weight-light black--text "
                                >Total Score</span
                              >
                              <span class=" blue--text text--darken-3 ">
                                {{ school.melab_minimum_score }}</span
                              >
                            </v-layout>
                            <v-divider
                              v-if="
                                school.melab_minimum_score !== '' &&
                                  school.melab_minimum_score !== undefined
                              "
                              class="mt-1 mb-1 mx-2"
                            ></v-divider>
                          </v-layout>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>

                    <!-- PTE Academic -->
                    <v-expansion-panels
                      v-if="school.pteAcademic_required"
                      class="mt-3 px-2 elevation-0"
                    >
                      <v-expansion-panel>
                        <v-expansion-panel-header class="py-1">
                          <v-layout row align-center>
                            <span
                              class="ml-2 blue--text text--darken-3 font-weight-medium"
                              >PTE Academic</span
                            >
                          </v-layout>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content style="borderRadius:5px;">
                          <v-layout
                            v-if="
                              school.pteAcademic_minimum_score === '' ||
                                school.pteAcademic_minimum_score === undefined
                            "
                            align-center
                            justify-center
                            py-2
                            class="grey--text white"
                          >
                            No Minimum Score Required
                          </v-layout>

                          <v-layout
                            v-if="
                              school.pteAcademic_minimum_score !== '' &&
                                school.pteAcademic_minimum_score !== undefined
                            "
                            column
                            class="pl-0 ml-0 "
                          >
                            <v-layout
                              justify-center
                              align-center
                              class="pl-2 font-weight-regular red--text"
                            >
                              Minimum Scores Required
                            </v-layout>

                            <!-- Total score -->
                            <v-layout
                              v-if="
                                school.pteAcademic_minimum_score !== '' &&
                                  school.pteAcademic_minimum_score !== undefined
                              "
                              mt-3
                              row
                              align-center
                              justify-space-between
                              mx-2
                            >
                              <span class=" font-weight-light black--text "
                                >Total Score</span
                              >
                              <span class=" blue--text text--darken-3 ">
                                {{ school.pteAcademic_minimum_score }}</span
                              >
                            </v-layout>
                            <v-divider
                              v-if="
                                school.pteAcademic_minimum_score !== '' &&
                                  school.pteAcademic_minimum_score !== undefined
                              "
                              class="mt-1 mb-1 mx-2"
                            ></v-divider>
                          </v-layout>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>

                    <!-- iTEP Academic-Plus -->
                    <v-expansion-panels
                      v-if="school.itepAcademicPlus_required"
                      class="mt-3 px-2 elevation-0"
                    >
                      <v-expansion-panel>
                        <v-expansion-panel-header class="py-1">
                          <v-layout row align-center>
                            <span
                              class="ml-2 blue--text text--darken-3 font-weight-medium"
                              >iTEP Academic-Plus</span
                            >
                          </v-layout>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content style="borderRadius:5px;">
                          <v-layout
                            v-if="
                              school.itepAcademicPlus_minimum_score === '' ||
                                school.itepAcademicPlus_minimum_score ===
                                  undefined
                            "
                            align-center
                            justify-center
                            py-2
                            class="grey--text white"
                          >
                            No Minimum Score Required
                          </v-layout>

                          <v-layout
                            v-if="
                              school.itepAcademicPlus_minimum_score !== '' &&
                                school.itepAcademicPlus_minimum_score !==
                                  undefined
                            "
                            column
                            class="pl-0 ml-0 "
                          >
                            <v-layout
                              justify-center
                              align-center
                              class="pl-2 font-weight-regular red--text"
                            >
                              Minimum Scores Required
                            </v-layout>

                            <!-- Total score -->
                            <v-layout
                              v-if="
                                school.itepAcademicPlus_minimum_score !== '' &&
                                  school.itepAcademicPlus_minimum_score !==
                                    undefined
                              "
                              mt-3
                              row
                              align-center
                              justify-space-between
                              mx-2
                            >
                              <span class=" font-weight-light black--text "
                                >Total Score</span
                              >
                              <span class=" blue--text text--darken-3 ">
                                {{
                                  school.itepAcademicPlus_minimum_score
                                }}</span
                              >
                            </v-layout>
                            <v-divider
                              v-if="
                                school.itepAcademicPlus_minimum_score !== '' &&
                                  school.itepAcademicPlus_minimum_score !==
                                    undefined
                              "
                              class="mt-1 mb-1 mx-2"
                            ></v-divider>
                          </v-layout>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card>

                  <!-- No Exams Required -->
                  <v-card
                    v-else
                    class="mt-5 elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout justify-center class=" grey pb-2 ">
                      <span
                        class="subtitle-1 mt-2 font-weight-regular white--text "
                        >English Proficiency Exams Not Required
                      </span>
                    </v-layout>
                  </v-card>

                  <!-- CONDITIONS -->
                  <v-card
                    v-if="
                      school.toefl_required ||
                        school.ielts_required ||
                        school.melab_required ||
                        school.pteAcademic_required ||
                        school.itepAcademicPlus_required
                    "
                    class="mt-5 elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout justify-center class=" grey lighten-3 pb-2 ">
                      <span class="subtitle-1 mt-2 font-weight-regular">
                        Conditions
                      </span>
                    </v-layout>

                    <v-card-text class="pt-2  ">
                      <v-layout>
                        <span
                          v-if="
                            school.toefl_minimum_years_completed !== '' &&
                              school.toefl_minimum_years_completed !== undefined
                          "
                          class="font-weight-light black--text"
                          >English Proficiency Exams should be completed within
                          <span
                            class="font-weight-medium blue--text text--darken-3"
                            >{{
                              school.toefl_minimum_years_completed
                            }}
                            years</span
                          ></span
                        >
                        <span v-else class="font-weight-light black--text"
                          >English Proficiency Exams should be completed within
                          <span
                            class="font-weight-medium blue--text text--darken-3"
                            >2 years</span
                          ></span
                        >
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <!-- EXEMPTIONS -->
                  <v-card
                    v-if="school.toefl_exempt_masters_doctoral_degrees"
                    class="mt-5 elevation-0 innerCardCover"
                    outlined
                  >
                    <v-layout justify-center class=" grey lighten-3 pb-2 ">
                      <span class="subtitle-1 mt-2 font-weight-regular">
                        Exemptions</span
                      >
                    </v-layout>

                    <v-card-text class="pt-2  ">
                      <v-layout column class="pl-0 ml-0 ">
                        <!--
                          ENGLISH EXAMS EXEMPT WITH MASTERS OR DOCTORAL DEGREE
                        -->
                        <v-layout mt-2 row align-center mx-0>
                          <span class=" font-weight-light black--text "
                            >TOFEL exempt with Masters or Doctoral Degree</span
                          >
                        </v-layout>
                      </v-layout>
                    </v-card-text>
                  </v-card>

                  <!-- International Notes -->
                  <v-card
                    v-if="school.internationalExamsNotes"
                    outlined
                    class=" mt-4 mb-4"
                  >
                    <v-layout align-center justify-center class=" pb-1">
                      <v-icon small class="mr-2"
                        >mdi-message-text-outline</v-icon
                      >
                      <span class="font-weight-light align-center"
                        >Additional Notes
                      </span>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-text class="text-center">
                      <span>{{ school.internationalExamsNotes }}</span>
                    </v-card-text>
                  </v-card>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import userMixins from "@/mixins/usersmixin";
export default {
  mixins: [userMixins],
  props: ["school"],
  data() {
    return {
      coursecategorytab: null,
      showIbtDialog: false,
      showPbtDialog: false,
      showAcceptedExpDialog: false,
      showCaspaCalulationMethod: false,
      showCoursesCategory: false,
      loadedCategory: null
    };
  },
  filters: {
    capitalizeString(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  },
  methods: {
    requiredCourseCategoryDialog(category) {
      this.showCoursesCategory = true;
      this.loadedCategory = category;
    },
    getIconColor(required, preferred) {
      if (required) {
        return "red";
      } else {
        return "amber darken-3";
      }
    }
  },
  computed: {}
};
</script>

<style scoped>
.v-expansion-panel::before {
  box-shadow: 0 10px 20px -10px rgba(0, 0, 0, 0.19) !important;
}
#borderCard {
  border: 1px solid rgb(228, 228, 228);
}
.percentageValue {
  color: rgb(85, 85, 85);
  font-size: 14px;
}

.card {
  border-radius: 10px;
}

#buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.19);
}

#secondaryButtonShadow {
  box-shadow: 0 10px 20px -11px rgba(0, 0, 0, 0.19);
  border-radius: 10px;
}

.innerCardCover {
  border-radius: 5px;
  padding: 0;
  margin-top: 12px;
  margin-bottom: 12px;
}

@media (min-width: 960px) {
  /* .innerCardCover {
    padding: 16px;
  } */
}
.responsiveImage {
  width: 100%;
  display: block;
}

.no_border_radius {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
</style>

<style>
.v-expansion-panel::before {
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Schools/SchoolDetail/AdmissionRequirements.vue